import { generateClient } from "aws-amplify/api";
import { fetchUserAttributes } from "aws-amplify/auth";
import { useEffect, useState } from "react";
import { createNotifications } from "../graphql/mutations.js";
import {
  listAssessmentAnswers,
  listAssessmentScores,
  listUserLinks,
} from "../graphql/queries.js";

const client = generateClient();

const traumaExperiences = [
  {
    key: "TRHurtfulNames",
    label:
      "Frequently Called Hurtful Names and Cussed at By Parent, Guardian, or Lover (e.g. mental abuse)",
  },
  {
    key: "TRNoNurturing",
    label:
      "Not Provided Attention, Support, or Nurturing Consistently By Parent or Guardian (e.g. emotional abuse)",
  },
  {
    key: "TRHit",
    label:
      "Punched, Smacked, Pushed, Tripped, etc. By a Parent, Guardian, or Lover (e.g. physical abuse)",
  },
  {
    key: "TRNeedsNotMet",
    label:
      "Not Provided Food or Clothing Consistently By a Parent or Guardian (e.g. neglect)",
  },
  {
    key: "TRForcedSex",
    label: "Involved in Unwanted or Forced Sexual Activity (e.g. rape)",
  },
  {
    key: "TRResponsible",
    label: "Adult Responsibilities as a Child Consistently (e.g. paying bills)",
  },
  { key: "TRViolence", label: "Witnessed Violence Consistently at Home" },
  {
    key: "TRSubstanceAbuse",
    label: "Witnessed Substance Abuse Consistently at Home",
  },
  {
    key: "TRMentalIllness",
    label: "Witnessed Mental Illness Consistently at Home",
  },
  { key: "TRParentDivorce", label: "Witnessed Parent(s) Separation/Divorce" },
  { key: "TRParentIncarcerated", label: "Witnessed Parent(s) Incarcerated" },
  {
    key: "TRHomelessness",
    label:
      "Experienced Homelessness or Moving Consistently (e.g. shelter, street, foster care)",
  },
  {
    key: "TRBodyFunction",
    label:
      "Experienced a Loss of Limb(s), Major Bodily Functions, or Extreme Sickness (e.g. cancer)",
  },
  {
    key: "TRNaturalDisaster",
    label:
      "Experienced a Significant Natural Disaster (e.g. loss of home/family)",
  },
  {
    key: "TRDirectTerrorism",
    label:
      "Directly Affected by Terrorism, Community, or School Violence (e.g. gangs, racism)",
  },
  {
    key: "TRIndirectTerrorism",
    label:
      "Indirectly Affected by Terrorism, Community, or School Violence (e.g. school shooting)",
  },
  {
    key: "TRLovedOne",
    label:
      "Absent, Inactive, or Death of a Close Loved One (e.g. parental figure or child)",
  },
];

const traumaResponseOptions = [
  {
    key: "TRResponseProfessional",
    label: "I talked to a professional or counselor about my trauma",
  },
  {
    key: "TRResponseFamilyFriend",
    label: "I talked to my family and/or friends about my trauma",
  },
  { key: "TRResponseGod", label: "I talked to God about my trauma" },
  { key: "TRResponseNoOne", label: "I didn’t talk to anyone about my trauma" },
  { key: "TRNoTrauma", label: "N/A (I didn't experience trauma)" },
];

const considerTraumaOptions = [
  { key: "Yes", label: "Yes" },
  { key: "No", label: "No" },
  { key: "NA", label: "N/A (I didn't experience any of the above)" },
];

const copingMechanisms = [
  { key: "CMAlcohol", label: "Alcohol" },
  { key: "CMDrugs", label: "Drugs" },
  { key: "CMOvereating", label: "Overeating" },
  { key: "CMSmoking", label: "Smoking" },
  { key: "CMGaming", label: "Gaming" },
  { key: "CMShopping", label: "Shopping" },
  { key: "CMGambling", label: "Gambling" },
  { key: "CMSex", label: "Casual Sex" },
  { key: "CMPorn", label: "Pornography" },
  { key: "CMBlaming", label: "Blaming Self or Others" },
  { key: "CMHurting", label: "Hurting Self or Others" },
  { key: "CMDisengage", label: "Disengagement/Detachment/Self Isolation" },
  { key: "CMArt", label: "Drawing/Painting/Art" },
  { key: "CMMusic", label: "Music" },
  { key: "CMPoetry", label: "Poetry/Poetical Lyrics" },
  { key: "CMReading", label: "Reading" },
  { key: "CMGroups", label: "Group Discussion" },
  { key: "CMCounseling", label: "Individual Counseling" },
  { key: "CMVenting", label: "Talking/Venting" },
  { key: "CMWriting", label: "Writing/Journaling" },
  { key: "CMSensory", label: "Sensory/Fidgets" },
  { key: "CMDancing", label: "Dancing" },
  { key: "CMExercising", label: "Exercising" },
  { key: "CMWalking", label: "Walking" },
  { key: "CMChange", label: "Change Something for Different Results" },
  { key: "CMAnalyze", label: "Analyze the Situation for Better Understanding" },
  { key: "CMDaydream", label: "Daydream or Imagine a Better Situation" },
  { key: "CMPositive", label: "Focus on the Positives" },
];

const frequencyOptions = [
  "5+x Week",
  "3-4x Week",
  "1-2x Week",
  "1-2x Month",
  "N/A-Rare",
];

const frequencyOptions2 = [
  "Strongly Agree",
  "Agree",
  "Neither",
  "Disagree",
  "Strongly Disagree",
];
const mentalHealthoptions = [
  { key: "MHDxPTSD", label: "Post-Traumatic Stress Disorder Diagnosis" },
  { key: "MHDxDepression", label: "Depression Diagnosis" },
  { key: "MHDxSUD", label: "Substance Use Disorder Diagnosis" },
  { key: "MHDxOtherMental", label: "Other Serious Mental Health Diagnosis" },
];
const mentalHealth = [
  { key: "MHSleeplessness", label: "Sleeplessness" },
  { key: "MHAlcoholUse", label: "Alcohol Use" },
  { key: "MHAnxiety", label: "Fight, Flight, Freeze" },
  { key: "MHDepression", label: "Depression" },
  { key: "MHDrugUse", label: "Drug Use" },
  { key: "MHGrief", label: "Grief" },
  { key: "MHGuilt", label: "Guilt" },
  { key: "MHIrritability", label: "Irritability" },
  { key: "MHStress", label: "Stress" },
  { key: "MHRegret", label: "Regret" },
  { key: "MHSuicidalThoughts", label: "Suicidal Thoughts" },
  { key: "MHLoneliness", label: "Loneliness" },
  { key: "MHWorry", label: "Worry / Anxiety" },
  { key: "MHHope", label: "Hopelessness" },
  { key: "MHPeace", label: "Inner Turmoil" },
  { key: "MHJoy", label: "Emptiness" },
];

const physicalHealthOptions = [
  { key: "PHDxInfertility", label: "Pregnancy/Fertility Issues" },
  { key: "PHDxCurableSTD", label: "Curable STD/STI Diagnosis" },
  { key: "PHDxIncurableSTD", label: "Incurable STD Diagnosis" },
  { key: "PHDxCancer", label: "Cancer Diagnosis" },
  { key: "PHDxDiabetes", label: "Diabetes Diagnosis" },
  { key: "PHDxHighBlood", label: "High Blood Pressure Diagnosis" },
  { key: "PHDxHeartDisease", label: "Heart Disease Diagnosis" },
  { key: "PHDxIrritableBowel", label: "Irritable Bowel Issues" },
  { key: "PHDxVitA", label: "Severe Vitamin A Deficiency" },
  { key: "PHDxVitB", label: "Severe Vitamin B Deficiency" },
  { key: "PHDxVitC", label: "Severe Vitamin C Deficiency" },
  { key: "PHDxVitD", label: "Severe Vitamin D Deficiency" },
  { key: "PHDxVitE", label: "Severe Vitamin E Deficiency" },
  { key: "PHDxVitK", label: "Severe Vitamin K Deficiency" },
  { key: "PHDxAutoimmune", label: "Autoimmune Disease Diagnosis" },
  {
    key: "PHDxOtherPhysical",
    label: "Other Serious Physical Health Diagnosis",
  },
];

const physicalHealth = [
  { key: "PHVegeFruits", label: "Vegetables and/or fruit?" },
  { key: "PHBeanLentils", label: "Beans and/or lentils?" },
  { key: "PHGrainBreads", label: "Grains and/or breads?" },
  { key: "PHDairy", label: "Dairy?" },
  { key: "PHMeat", label: "Animal Meat?" },
  { key: "PHFishSeafood", label: "Fish/seafood?" },
  { key: "PHSweets", label: "Sweets/desserts?" },
  { key: "PHWater", label: "Water?" },
  { key: "PHPhysicalActivity", label: "Physically active?" },
];

const spiritualHealthOptions = [
  {
    key: "SHSpiritualDefine",
    label: "God or a higher power loves me and is interested in my good.",
  },
  {
    key: "SHSpiritualIntegrate",
    label: "Spirituality is integrated into my whole life.",
  },
  { key: "SHPrayer", label: "Pray?" },
  {
    key: "SHSpiritualActivity",
    label: "Communicate with like-minded individuals?",
  },
  { key: "SHReadText", label: "Read religious text?" },
  {
    key: "SHAlignText",
    label: "Consciously try to align your life with religious texts?",
  },
  {
    key: "SHCommunity",
    label: "Participate in religious gatherings / groups / prayer?",
  },
];

const socialhealth = [
  { key: "SoHLearning", label: "Willingness to learn and be corrected?" },
  {
    key: "SoHStable",
    label: "Financially stable (e.g. housing, transportation, etc.)?",
  },
  { key: "SoHSafety", label: "Safe and secure in your environments?" },
  { key: "SoHKindness", label: "Kindness toward others?" },
  {
    key: "SoHForgiveness",
    label: "Like you were able to forgive yourself and others?",
  },
  { key: "SoHPatience", label: "Patience with yourself and others?" },
  { key: "SoHRelationships", label: "Supported in your relationships?" },
  {
    key: "SoHContribution",
    label: "Like you contributed to others / your community?",
  },
  {
    key: "SoHBoundaries",
    label: "Like you were able to maintain healthy boundaries?",
  },
  {
    key: "SoHEUnpleasant",
    label: "Unpleasant emotions (e.g. frustration, irritability)?",
  },
  {
    key: "SoHEPleasant",
    label: "Pleasant emotions (e.g. appreciation, confidence)?",
  },
  { key: "SoHEControl", label: "Control over your emotions?" },
];

export const assessmentQuestionLabelByKey = Object.fromEntries(
  [
    ...(traumaExperiences || []),
    ...(traumaResponseOptions || []),
    ...(copingMechanisms || []),
    ...(mentalHealthoptions || []),
    ...(mentalHealth || []),
    ...(physicalHealthOptions || []),
    ...(physicalHealth || []),
    ...(spiritualHealthOptions || []),
    ...(socialhealth || []),
  ]
    .filter((x) => x && typeof x === "object")
    .map((x) => [x.key, x.label]),
);

const schemaDefaults = {
  MHDxPTSD: false,
  MHDxDepression: false,
  MHDxSUD: false,
  MHDxOtherMental: false,
  MHSleeplessness: "No Answer",
  MHAlcoholUse: "No Answer",
  MHAnxiety: "No Answer",
  MHDepression: "No Answer",
  MHDrugUse: "No Answer",
  MHGrief: "No Answer",
  MHGuilt: "No Answer",
  MHIrritability: "No Answer",
  MHStress: "No Answer",
  MHRegret: "No Answer",
  MHSuicidalThoughts: "No Answer",
  MHLoneliness: "No Answer",
  MHWorry: "No Answer",
  MHHope: "No Answer",
  MHPeace: "No Answer",
  MHJoy: "No Answer",

  PHDxInfertility: false,
  PHDxCurableSTD: false,
  PHDxIncurableSTD: false,
  PHDxCancer: false,
  PHDxDiabetes: false,
  PHDxHighBlood: false,
  PHDxHeartDisease: false,
  PHDxIrritableBowel: false,
  PHDxVitA: false,
  PHDxVitB: false,
  PHDxVitC: false,
  PHDxVitD: false,
  PHDxVitE: false,
  PHDxVitK: false,
  PHDxAutoimmune: false,
  PHDxOtherPhysical: false,

  PHVegeFruits: "No Answer",
  PHBeanLentils: "No Answer",
  PHGrainBreads: "No Answer",
  PHDairy: "No Answer",
  PHMeat: "No Answer",
  PHFishSeafood: "No Answer",
  PHSweets: "No Answer",
  PHWater: "No Answer",
  PHPhysicalActivity: "No Answer",

  SHSpiritualDefine: "No Answer",
  SHSpiritualIntegrate: "No Answer",
  SHPrayer: "No Answer",
  SHSpiritualActivity: "No Answer",
  SHReadText: "No Answer",
  SHAlignText: "No Answer",
  SHCommunity: "No Answer",

  SoHLearning: "No Answer",
  SoHStable: "No Answer",
  SoHSafety: "No Answer",
  SoHKindness: "No Answer",
  SoHForgiveness: "No Answer",
  SoHPatience: "No Answer",
  SoHRelationships: "No Answer",
  SoHContribution: "No Answer",
  SoHBoundaries: "No Answer",
  SoHEUnpleasant: "No Answer",
  SoHEPleasant: "No Answer",
  SoHEControl: "No Answer",

  SDoHAgeRange: "No Answer",
  SDoHRace: "No Answer",
  SDoHGeographicRegion: "No Answer",
  SDoHEthnicity: "No Answer",
  SDoHState: "No Answer",
  SDoHZipCode: "No Answer",
  SDoHMaritalStatus: "No Answer",
  SDoHMilitaryStatus: "No Answer",
  SDoHGender: "No Answer",
  SDoHEducation: "No Answer",
  SDoHJobStatus: "No Answer",
  SDoHIncome: "No Answer",
  SDoHHousingStatus: "No Answer",
  SDoHHomeAsChild: "No Answer",
  SDoHReligion: "No Answer",
  SDoHDenomination: "No Answer",
};

const scoreDefaults = {
  // Trauma Scores
  TRHurtfulNames: 0,
  TRNoNurturing: 0,
  TRHit: 0,
  TRNeedsNotMet: 0,
  TRForcedSex: 0,
  TRResponsible: 0,
  TRViolence: 0,
  TRSubstanceAbuse: 0,
  TRMentalIllness: 0,
  TRParentDivorce: 0,
  TRParentIncarcerated: 0,
  TRHomelessness: 0,
  TRBodyFunction: 0,
  TRNaturalDisaster: 0,
  TRDirectTerrorism: 0,
  TRIndirectTerrorism: 0,
  TRLovedOne: 0,
  TRBelief: 0,
  TRResponseProfessional: 0,
  TRResponseFamilyFriend: 0,
  TRResponseGod: 0,
  TRResponseNoOne: 0,
  TRNoTrauma: 0,

  // Coping Mechanism Scores
  CMAlcohol: 0,
  CMDrugs: 0,
  CMOvereating: 0,
  CMSmoking: 0,
  CMGaming: 0,
  CMShopping: 0,
  CMGambling: 0,
  CMSex: 0,
  CMPorn: 0,
  CMBlaming: 0,
  CMHurting: 0,
  CMDisengage: 0,
  CMArt: 0,
  CMMusic: 0,
  CMPoetry: 0,
  CMReading: 0,
  CMGroups: 0,
  CMCounseling: 0,
  CMVenting: 0,
  CMWriting: 0,
  CMSensory: 0,
  CMDancing: 0,
  CMExercising: 0,
  CMWalking: 0,
  CMChange: 0,
  CMAnalyze: 0,
  CMDaydream: 0,
  CMPositive: 0,

  // Mental Health
  MHDxPTSD: 0,
  MHDxDepression: 0,
  MHDxSUD: 0,
  MHDxOtherMental: 0,
  MHSleeplessness: 0,
  MHAlcoholUse: 0,
  MHAnxiety: 0,
  MHDepression: 0,
  MHDrugUse: 0,
  MHGrief: 0,
  MHGuilt: 0,
  MHIrritability: 0,
  MHStress: 0,
  MHRegret: 0,
  MHSuicidalThoughts: 0,
  MHLoneliness: 0,
  MHWorry: 0,
  MHHope: 0,
  MHPeace: 0,
  MHJoy: 0,

  // Physical Health
  PHDxInfertility: 0,
  PHDxCurableSTD: 0,
  PHDxIncurableSTD: 0,
  PHDxCancer: 0,
  PHDxDiabetes: 0,
  PHDxHighBlood: 0,
  PHDxHeartDisease: 0,
  PHDxIrritableBowel: 0,
  PHDxVitA: 0,
  PHDxVitB: 0,
  PHDxVitC: 0,
  PHDxVitD: 0,
  PHDxVitE: 0,
  PHDxVitK: 0,
  PHDxAutoimmune: 0,
  PHDxOtherPhysical: 0,
  PHVegeFruits: 0,
  PHBeanLentils: 0,
  PHGrainBreads: 0,
  PHDairy: 0,
  PHMeat: 0,
  PHFishSeafood: 0,
  PHSweets: 0,
  PHWater: 0,
  PHPhysicalActivity: 0,

  // Spiritual
  SHSpiritualDefine: 0,
  SHSpiritualIntegrate: 0,
  SHPrayer: 0,
  SHSpiritualActivity: 0,
  SHReadText: 0,
  SHAlignText: 0,
  SHCommunity: 0,

  // Social
  SoHLearning: 0,
  SoHStable: 0,
  SoHSafety: 0,
  SoHKindness: 0,
  SoHForgiveness: 0,
  SoHPatience: 0,
  SoHRelationships: 0,
  SoHContribution: 0,
  SoHBoundaries: 0,
  SoHEUnpleasant: 0,
  SoHEPleasant: 0,
  SoHEControl: 0,

  // Social Determinants of Health (set as No Answer since they are strings)
  SDoHAgeRange: "No Answer",
  SDoHRace: "No Answer",
  SDoHGeographicRegion: "No Answer",
  SDoHEthnicity: "No Answer",
  SDoHState: "No Answer",
  SDoHZipCode: "No Answer",
  SDoHMaritalStatus: "No Answer",
  SDoHMilitaryStatus: "No Answer",
  SDoHGender: "No Answer",
  SDoHEducation: "No Answer",
  SDoHJobStatus: "No Answer",
  SDoHIncome: "No Answer",
  SDoHHousingStatus: "No Answer",
  SDoHHomeAsChild: "No Answer",
  SDoHReligion: "No Answer",
  SDoHDenomination: "No Answer",
};

const createAssessmentAnswersMutation = `
  mutation CreateAssessmentAnswers($input: CreateAssessmentAnswersInput!) {
    createAssessmentAnswers(input: $input) {
      id
    }
  }
`;

const updateAssessmentAnswersMutation = `
  mutation UpdateAssessmentAnswers($input: UpdateAssessmentAnswersInput!) {
    updateAssessmentAnswers(input: $input) {
      id
    }
  }
`;

const createAssessmentScoresMutation = `
  mutation CreateAssessmentScores($input: CreateAssessmentScoresInput!) {
    createAssessmentScores(input: $input) {
      id
    }
  }
`;

const listActiveAssessmentAnswerIdsQuery = `
  query ListActiveAssessmentAnswerIds($filter: ModelAssessmentAnswersFilterInput, $limit: Int) {
    listAssessmentAnswers(filter: $filter, limit: $limit) {
      items {
        id
        isActive
        createdAt
        updatedAt
      }
    }
  }
`;

const listActiveAssessmentScoreIdsQuery = `
  query ListActiveAssessmentScoreIds($filter: ModelAssessmentScoresFilterInput, $limit: Int) {
    listAssessmentScores(filter: $filter, limit: $limit) {
      items {
        id
        isActive
        createdAt
        updatedAt
      }
    }
  }
`;

const updateAssessmentScoresMutation = `
  mutation UpdateAssessmentScores($input: UpdateAssessmentScoresInput!) {
    updateAssessmentScores(input: $input) {
      id

    }
  }
`;
// Whitelist of allowed fields for AssessmentScores input (from GraphQL schema)
const allowedAssessmentScoresFields = [
  "CMAlcohol",
  "CMAnalyze",
  "CMArt",
  "CMBlaming",
  "CMChange",
  "CMCounseling",
  "CMDancing",
  "CMDaydream",
  "CMDisengage",
  "CMDrugs",
  "CMExercising",
  "CMGambling",
  "CMGaming",
  "CMGroups",
  "CMHurting",
  "CMMusic",
  "CMOvereating",
  "CMPoetry",
  "CMPorn",
  "CMPositive",
  "CMReading",
  "CMScore",
  "CMSensory",
  "CMSex",
  "CMShopping",
  "CMSmoking",
  "CMVenting",
  "CMWalking",
  "CMWriting",
  "CompletedDate",
  "CompletedTime",
  "MHAlcoholUse",
  "MHAnxiety",
  "MHDepression",
  "MHDrugUse",
  "MHDxDepression",
  "MHDxOtherMental",
  "MHDxPTSD",
  "MHDxSUD",
  "MHGrief",
  "MHGuilt",
  "MHIrritability",
  "MHLoneliness",
  "MHRegret",
  "MHScore",
  "MHSleeplessness",
  "MHStress",
  "MHSuicidalThoughts",
  "MHWorry",
  "MHHope",
  "MHPeace",
  "MHJoy",
  "PHBeanLentils",
  "PHDairy",
  "PHDxAutoimmune",
  "PHDxCancer",
  "PHDxCurableSTD",
  "PHDxDiabetes",
  "PHDxHeartDisease",
  "PHDxHighBlood",
  "PHDxIncurableSTD",
  "PHDxInfertility",
  "PHDxIrritableBowel",
  "PHDxOtherPhysical",
  "PHDxVitA",
  "PHDxVitB",
  "PHDxVitC",
  "PHDxVitD",
  "PHDxVitE",
  "PHDxVitK",
  "PHFishSeafood",
  "PHGrainBreads",
  "PHMeat",
  "PHPhysicalActivity",
  "PHScore",
  "PHSweets",
  "PHVegeFruits",
  "PHWater",
  "ProAssessmentFinalizedName1",
  "ProAssessmentFinalizedName2",
  "ProAssessmentFinalizedName3",
  "ProAssessmentFinalizedReview1",
  "ProAssessmentFinalizedReview2",
  "ProAssessmentFinalizedReview3",
  "ProAssessmentFinalizedReviewDate1",
  "ProAssessmentFinalizedReviewDate2",
  "ProAssessmentFinalizedReviewDate3",
  "ProAssessmentFinalizedRole1",
  "ProAssessmentFinalizedRole2",
  "ProAssessmentFinalizedRole3",
  "SDoHAgeRange",
  "SDoHDenomination",
  "SDoHEducation",
  "SDoHEthnicity",
  "SDoHGender",
  "SDoHGeographicRegion",
  "SDoHHomeAsChild",
  "SDoHHousingStatus",
  "SDoHIncome",
  "SDoHJobStatus",
  "SDoHMaritalStatus",
  "SDoHMilitaryStatus",
  "SDoHRace",
  "SDoHReligion",
  "SDoHState",
  "SDoHZipCode",
  "SHAlignText",
  "SHCommunity",
  "SHPrayer",
  "SHReadText",
  "SHScore",
  "SHSkip",
  "SHSpiritualActivity",
  "SHSpiritualDefine",
  "SHSpiritualIntegrate",
  "SoHBoundaries",
  "SoHContribution",
  "SoHEControl",
  "SoHEPleasant",
  "SoHEUnpleasant",
  "SoHForgiveness",
  "SoHKindness",
  "SoHLearning",
  "SoHPatience",
  "SoHRelationships",
  "SoHSafety",
  "SoHScore",
  "SoHStable",
  "TRBelief",
  "TRBodyFunction",
  "TRDirectTerrorism",
  "TRForcedSex",
  "TRHit",
  "TRHomelessness",
  "TRHurtfulNames",
  "TRIndirectTerrorism",
  "TRLovedOne",
  "TRMentalIllness",
  "TRNaturalDisaster",
  "TRNeedsNotMet",
  "TRNoNurturing",
  "TRNoTrauma",
  "TRParentDivorce",
  "TRParentIncarcerated",
  "TRResponseFamilyFriend",
  "TRResponseGod",
  "TRResponseNoOne",
  "TRResponseProfessional",
  "TRResponsible",
  "TRScore",
  "TRSubstanceAbuse",
  "TRViolence",
  "id",
  "isActive",
  "organizationId",
  "userId",
];

function filterToAllowed(obj) {
  const out = {};
  for (const k of allowedAssessmentScoresFields) {
    if (Object.prototype.hasOwnProperty.call(obj, k)) out[k] = obj[k];
  }
  return out;
}

function mapToLegacyAssessmentFieldNames(obj) {
  return { ...obj };
}

function getErrorMessage(error, fallback) {
  if (!error) return fallback;
  if (typeof error === "string") return error;
  if (Array.isArray(error?.errors) && error.errors.length > 0) {
    return error.errors.map((item) => item?.message || String(item)).join("; ");
  }
  if (typeof error?.message === "string" && error.message.trim()) {
    return error.message;
  }
  try {
    return JSON.stringify(error);
  } catch {
    return fallback;
  }
}

function throwIfGraphqlErrors(result, context) {
  if (result?.errors?.length) {
    throw new Error(getErrorMessage(result, context));
  }
  return result;
}

const SDOHKeys = [
  { key: "SDoHAgeRange" },
  { key: "SDoHRace" },
  { key: "SDoHGeographicRegion" },
  { key: "SDoHEthnicity" },
  { key: "SDoHState" },
  { key: "SDoHZipCode" },
  { key: "SDoHMaritalStatus" },
  { key: "SDoHMilitaryStatus" },
  { key: "SDoHGender" },
  { key: "SDoHEducation" },
  { key: "SDoHJobStatus" },
  { key: "SDoHIncome" },
  { key: "SDoHHousingStatus" },
  { key: "SDoHHomeAsChild" },
  { key: "SDoHReligion" },
  { key: "SDoHDenomination" },
];

const assessmentAnswerKeysBySection = {
  trauma: [
    ...traumaExperiences.map(({ key }) => key),
    ...traumaResponseOptions.map(({ key }) => key),
    "TRBelief",
  ],
  coping: copingMechanisms.map(({ key }) => key),
  mental: [
    ...mentalHealthoptions.map(({ key }) => key),
    ...mentalHealth.map(({ key }) => key),
  ],
  physical: [
    ...physicalHealthOptions.map(({ key }) => key),
    ...physicalHealth.map(({ key }) => key),
  ],
  spiritual: spiritualHealthOptions.map(({ key }) => key),
  social: socialhealth.map(({ key }) => key),
  sdoh: SDOHKeys.map(({ key }) => key),
};

const assessmentScoreKeysBySection = {
  TR: [
    ...traumaExperiences.map(({ key }) => key),
    ...traumaResponseOptions.map(({ key }) => key),
    "TRBelief",
    "TRScore",
  ],
  CM: [...copingMechanisms.map(({ key }) => key), "CMScore"],
  MH: [
    ...mentalHealthoptions.map(({ key }) => key),
    ...mentalHealth.map(({ key }) => key),
    "MHScore",
  ],
  PH: [
    ...physicalHealthOptions.map(({ key }) => key),
    ...physicalHealth.map(({ key }) => key),
    "PHScore",
  ],
  SH: [...spiritualHealthOptions.map(({ key }) => key), "SHScore", "SHSkip"],
  SoH: [...socialhealth.map(({ key }) => key), "SoHScore"],
};
const ethnicityOptions = [
  "Alaskan",
  "Algerian",
  "American",
  "Apache",
  "Argentinian",
  "Barbadian",
  "Brazilian",
  "Cambodian",
  "Canadian",
  "Caribbean",
  "Chamorros",
  "Cherokee",
  "Chinese",
  "Choctaw",
  "Columbian",
  "Cuban",
  "Dominican",
  "Dutch",
  "Ecuadorian",
  "Egyptian",
  "English",
  "Ethiopian",
  "Fijians",
  "Filipino",
  "French",
  "German",
  "Ghanian",
  "Guatemalan",
  "Haitian",
  "Hawaiian",
  "Indian",
  "Iranian",
  "Iraqi",
  "Irish",
  "Israeli",
  "Italian",
  "Jamaican",
  "Japanese",
  "Kanaka Maoli",
  "Korean",
  "Kurdish",
  "Lebanese",
  "Lumbee",
  "Mexican",
  "Moroccan",
  "Native",
  "Navajo",
  "Nigerian",
  "Norwegian",
  "Ojibwe",
  "Polish",
  "Pueblo Sioux",
  "Puerto Rican",
  "Rapanui",
  "Russian",
  "Salvadoran",
  "Samoan",
  "Somalian",
  "South African",
  "Spaniard",
  "Sun'aq",
  "Syrian",
  "Tahitians",
  "Taiwanese",
  "Tibetan",
  "Tokelau",
  "Tongan",
  "Vietnamese",
  "I Don’t Know",
  "Mixed",
  "Other",
  "No Answer",
  "",
];

const IdentifyAsOptions = [
  "Black",
  "Brown",
  "White",
  "I Choose Not to Respond",
  "Other",
  "No Answer",
  "",
];
const NationalityOptions = [
  "Africa",
  "Asia",
  "Australia",
  "Canada",
  "Europe",
  "Middle East",
  "Russia",
  "South America",
  "United States",
  "I Don’t Know",
  "Other",
  "No Answer",
  "",
];
const GenderIdentityOptions = [
  "A male born as male",
  "A female born as female",
  "A male born as female",
  "A female born as male",
  "Other",
  "No Answer",
  "",
];
const HousingOptions = [
  "Rent",
  "Own/Mortgage",
  "Homeless",
  "Family/Friend",
  "Shelter",
  "Prison/Jail",
  "Other",
  "No Answer",
  "",
];
const HomeGrewUpOptions = [
  "2 Guardians/Parents",
  "1 Guardian/Parent",
  "Foster Care",
  "Varied/Unstable",
  "Other",
  "No Answer",
  "",
];
const DenominationOptions = [
  "Baptist",
  "Jehovah’s Witness",
  "Latter Day Saints",
  "Lutheran",
  "Messianic Judaism",
  "Methodist",
  "Non-Denominational",
  "Presbyterian",
  "Roman Catholic",
  "Seventh Day Adventist",
  "Other",
  "No Answer",
  "",
];

export default function Assessment({ setCurrentView }) {
  const isAssessmentRequired = true;
  const [formData, setFormData] = useState({});
  const [step, setStep] = useState("trauma");
  const [, setSuccessMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [userId, setUserId] = useState("");
  const [organizationId, setOrganizationId] = useState("");
  const [existingRecordId, setExistingRecordId] = useState(null);
  const [existingScoreId, setExistingScoreId] = useState(null);
  const [copingWarning, setCopingWarning] = useState(false);
  const [traumaWarning, setTraumaWarning] = useState("");
  const [mentalWarning, setMentalWarning] = useState("");
  const [physicalWarning, setPhysicalWarning] = useState("");
  const [spiritualWarning, setSpiritualWarning] = useState("");
  const [socialWarning, setSocialWarning] = useState("");
  const [sdohWarning, setSdohWarning] = useState("");
  const [unansweredCopingFields, setUnansweredCopingFields] = useState([]);
  const [unansweredMentalFields, setUnansweredMentalFields] = useState([]);
  const [unansweredPhysicalFields, setUnansweredPhysicalFields] = useState([]);
  const [unansweredSpiritualFields, setUnansweredSpiritualFields] = useState(
    [],
  );
  const [unansweredSocialFields, setUnansweredSocialFields] = useState([]);

  useEffect(() => {
    const section = localStorage.getItem("assessmentSection");
    // Load any saved draft from previous navigation
    try {
      const draft = localStorage.getItem("assessmentDraft");
      if (draft) {
        const parsed = JSON.parse(draft);
        if (parsed && typeof parsed === "object") setFormData(parsed);
      }
    } catch (e) {
      console.warn("Failed to parse assessment draft:", e);
    }
    if (section) {
      setStep(section);
      // Optional: clear it after reading
      localStorage.removeItem("assessmentSection");
    }
    async function loadUserAndRecord() {
      try {
        const attrs = await fetchUserAttributes();
        const uid = attrs.sub;
        setUserId(uid);

        const rawOrgId =
          attrs["custom:organizationId"] || attrs["custom:organizationID"];
        const accountType = attrs["custom:accountType"] || "";
        const effectiveOrgId =
          rawOrgId || (accountType === "Organization" ? uid : "");
        setOrganizationId(effectiveOrgId);

        const filter = {
          or: [{ userId: { eq: uid } }, { owner: { eq: uid } }],
          isActive: { eq: true },
        };

        // Query answers and scores separately using the generated queries and variables
        const answersRes = await client.graphql({
          query: listAssessmentAnswers,
          variables: { filter },
        });

        const scoresRes = await client.graphql({
          query: listAssessmentScores,
          variables: { filter },
        });

        const answerItems =
          answersRes?.data?.listAssessmentAnswers?.items || [];
        const scoreItems = scoresRes?.data?.listAssessmentScores?.items || [];
        const existingAnswer = [...answerItems].sort(
          (a, b) =>
            new Date(b?.updatedAt || b?.createdAt || 0) -
            new Date(a?.updatedAt || a?.createdAt || 0),
        )[0];
        const activeScore = [...scoreItems]
          .filter((item) => item?.isActive)
          .sort(
            (a, b) =>
              new Date(b?.updatedAt || b?.createdAt || 0) -
              new Date(a?.updatedAt || a?.createdAt || 0),
          )[0];

        if (existingAnswer) {
          setExistingRecordId(existingAnswer.id);

          // Normalize booleans
          const normalized = { ...existingAnswer };
          traumaExperiences.forEach(({ key }) => {
            normalized[key] = !!normalized[key];
          });
          traumaResponseOptions.forEach(({ key }) => {
            normalized[key] = !!normalized[key];
          });

          // Merge backend values with any locally saved draft (draft should win)
          setFormData((prev) => ({ ...normalized, ...prev }));

          // Set traumaBeliefKey separately based on score data
          let traumaBeliefKey = "NA";

          if (activeScore) {
            const trBeliefScore = activeScore.TRBelief;
            if (trBeliefScore === 0.01) traumaBeliefKey = "Yes";
            else if (trBeliefScore === 0.02) traumaBeliefKey = "No";
          } else {
            if (normalized.TRBelief === true) traumaBeliefKey = "Yes";
            else if (normalized.TRBelief === false) traumaBeliefKey = "No";
          }

          // Update traumaBeliefKey only if not present in draft
          setFormData((prev) => ({
            ...prev,
            traumaBeliefKey: prev?.traumaBeliefKey ?? traumaBeliefKey,
          }));

          // Set existing score id if any
          if (activeScore) {
            setExistingScoreId(activeScore.id);
          }
        }
      } catch (err) {
        console.error("Error loading record:", err);
      }
    }

    loadUserAndRecord();
  }, []);

  // Scroll to top whenever the step changes so new page starts at top
  useEffect(() => {
    try {
      window.scrollTo({ top: 0, behavior: "smooth" });
      const container = document.querySelector(".assessment-section");
      if (container && typeof container.scrollTo === "function") {
        container.scrollTo({ top: 0, behavior: "auto" });
      }
    } catch (e) {
      // ignore if running in non-browser environment
    }
  }, [step]);

  // Persist draft to localStorage so selections survive navigation
  useEffect(() => {
    try {
      // Only save when there is some form data
      if (formData && Object.keys(formData).length > 0) {
        localStorage.setItem("assessmentDraft", JSON.stringify(formData));
      }
    } catch (e) {
      console.warn("Failed to save assessment draft:", e);
    }
  }, [formData]);

  function validateAssessmentData(data) {
    const missingSections = [];

    // Trauma
    const traumaKeys = [
      "TRHurtfulNames",
      "TRNoNurturing",
      "TRHit",
      "TRNeedsNotMet",
      "TRForcedSex",
      "TRResponsible",
      "TRViolence",
      "TRSubstanceAbuse",
      "TRMentalIllness",
      "TRParentDivorce",
      "TRParentIncarcerated",
      "TRHomelessness",
      "TRBodyFunction",
      "TRNaturalDisaster",
      "TRDirectTerrorism",
      "TRIndirectTerrorism",
      "TRLovedOne",
      "TRBelief",
      "TRResponseProfessional",
      "TRResponseFamilyFriend",
      "TRResponseGod",
      "TRResponseNoOne",
      "TRNoTrauma",
    ];
    const traumaComplete = traumaKeys.some((k) => data[k] === true);
    if (!traumaComplete) missingSections.push("Trauma");

    // Coping (CM) — should not be "N/A"
    const copingKeys = Object.keys(data).filter((k) => k.startsWith("CM"));
    const copingComplete = copingKeys.every(
      (k) => data[k] && data[k] !== "N/A" && data[k] !== "No Answer",
    );
    if (!copingComplete) missingSections.push("Coping Mechanisms");

    // Mental Health (MH)
    const mentalKeys = [
      "MHSleeplessness",
      "MHAlcoholUse",
      "MHAnxiety",
      "MHDepression",
      "MHDrugUse",
      "MHGrief",
      "MHGuilt",
      "MHIrritability",
      "MHStress",
      "MHRegret",
      "MHSuicidalThoughts",
      "MHLoneliness",
      "MHWorry",
      "MHHope",
      "MHPeace",
      "MHJoy",
    ];
    const mentalComplete = mentalKeys.every(
      (k) => data[k] && data[k] !== "No Answer",
    );
    if (!mentalComplete) missingSections.push("Mental Health");

    // Physical Health (PH)
    const physicalKeys = [
      "PHVegeFruits",
      "PHBeanLentils",
      "PHGrainBreads",
      "PHDairy",
      "PHMeat",
      "PHFishSeafood",
      "PHSweets",
      "PHWater",
      "PHPhysicalActivity",
    ];
    const physicalComplete = physicalKeys.every(
      (k) => data[k] && data[k] !== "No Answer",
    );
    if (!physicalComplete) missingSections.push("Physical Health");

    // Social (SoH)
    const sohKeys = [
      "SoHLearning",
      "SoHStable",
      "SoHSafety",
      "SoHKindness",
      "SoHForgiveness",
      "SoHPatience",
      "SoHRelationships",
      "SoHContribution",
      "SoHBoundaries",
      "SoHEUnpleasant",
      "SoHEPleasant",
      "SoHEControl",
    ];
    const sohComplete = sohKeys.every(
      (k) => data[k] && data[k] !== "No Answer",
    );
    if (!sohComplete) missingSections.push("Overall Life Satisfaction");

    // SDoH (basic required ones)
    // const sdohKeys = [
    // "SDoHAgeRange", "SDoHRace", "SDoHGeographicRegion", "SDoHEthnicity",
    //  "SDoHState", "SDoHZipCode", "SDoHMaritalStatus", "SDoHMilitaryStatus",
    //  "SDoHGender", "SDoHEducation", "SDoHJobStatus", "SDoHIncome",
    //  "SDoHHousingStatus", "SDoHHomeAsChild", "SDoHReligion"
    // ];
    //const sdohComplete = sdohKeys.every((k) => data[k] && data[k] !== "No Answer");
    //if (!sdohComplete) missingSections.push("Social Determinants of Health");

    return missingSections;
  }

  function showIncompleteSectionWarning(section) {
    const warning =
      "Please complete all required fields before final submission.";

    switch (section) {
      case "Trauma":
        setTraumaWarning(warning);
        setStep("trauma");
        break;
      case "Coping Mechanisms":
        setCopingWarning(true);
        setStep("coping");
        break;
      case "Mental Health":
        setMentalWarning(warning);
        setStep("mental");
        break;
      case "Physical Health":
        setPhysicalWarning(warning);
        setStep("physical");
        break;
      case "Overall Life Satisfaction":
        setSocialWarning(warning);
        setStep("social");
        break;
      default:
        setSdohWarning(warning);
    }
  }

  const mergeDefaults = (input, options = {}) => {
    const { skipSDOH = false } = options;

    for (let key in schemaDefaults) {
      // If skipping SDOH keys, and this is one of them, continue
      if (skipSDOH && key.startsWith("SDoH")) continue;

      if (!(key in input)) {
        input[key] = schemaDefaults[key];
      }
    }
    return input;
  };
  function mergeScoreDefaults(input) {
    for (let key in scoreDefaults) {
      if (!(key in input)) input[key] = scoreDefaults[key];
    }
    return input;
  }

  function calculateScores6(formData, Domain) {
    const scoreData = {};
    let Total = 0;

    traumaExperiences.forEach(({ key }) => {
      scoreData[key] = formData[key] ? 1 : 0;
    });

    traumaResponseOptions.forEach(({ key }) => {
      scoreData[key] = formData[key] ? 0.01 : 0; // Keep as float for response options
    });

    // TRBelief special case (0.01 = yes, 0.02 = no, 0 = undefined)
    if (formData["TRBelief"] === true) {
      scoreData["TRBelief"] = 0.01;
    } else if (formData["TRBelief"] === false) {
      scoreData["TRBelief"] = 0.02;
    } else {
      scoreData["TRBelief"] = 0;
    }

    traumaExperiences.forEach(({ key }) => {
      if (formData[key])
        if (Domain === "TR") {
          Total += 1;
        }
    });
    if (formData["TRResponseNoOne"])
      if (Domain === "TR") {
        Total += 4;
      }

    const frequencyMapGroup1 = {
      "5+x Week": 4,
      "3-4x Week": 3,
      "1-2x Week": 2,
      "1-2x Month": 1,
      "N/A-Rare": 0,
      "No Answer": 0,
      "": 0,
      null: 0,
      undefined: 0,
    };

    // Define a different scoring for the second group
    // Example: simple boolean (1 if selected, else 0) or some custom mapping
    // For this example, let's assign 1 if selected, 0 if not
    const frequencyMapGroup2 = {
      "5+x Week": 0,
      "3-4x Week": 0.01,
      "1-2x Week": 0.02,
      "1-2x Month": 0.03,
      "N/A-Rare": 0.04,
      "No Answer": 0,
      "": 0,
      null: 0,
      undefined: 0,
    };

    // Separate coping mechanisms into two groups
    const group1Keys = copingMechanisms.slice(0, 12).map(({ key }) => key);
    // This includes: CMAlcohol, CMDrugs, CMOvereating, CMSmoking, CMGaming, CMShopping, CMGambling, CMSex, CMPorn, CMBlaming, CMHurting, CMDisengage
    const group2Keys = copingMechanisms.slice(12).map(({ key }) => key);
    // This includes: CMArt, CMMusic, CMPoetry, CMReading, CMGroups, CMCounseling, CMVenting, CMWriting, CMSensory, CMDancing, CMExercising, CMWalking, CMChange, CMAnalyze, CMDaydream, CMPositive

    // Calculate scores for group 1 with frequency map
    group1Keys.forEach((key) => {
      const freqScore = frequencyMapGroup1[formData[key]] ?? 0;
      scoreData[key] = freqScore;
      if (Domain === "CM") {
        Total += freqScore;
      }
    });

    // Calculate scores for group 2 with custom function
    group2Keys.forEach((key) => {
      const score = frequencyMapGroup2[formData[key]] ?? 0;
      scoreData[key] = score;
    });

    mentalHealthoptions.forEach(({ key }) => {
      scoreData[key] = formData[key] ? 0.01 : 0; // Keep as float for response options
    });

    const frequencyMapGroupm = {
      "5+x Week": 4,
      "3-4x Week": 3,
      "1-2x Week": 2,
      "1-2x Month": 1,
      "N/A-Rare": 0,
      "No Answer": 0,
      "": 0,
      null: 0,
      undefined: 0,
    };

    // Calculate scores for group 1 with frequency map
    mentalHealth.forEach(({ key }) => {
      const freqScore = frequencyMapGroupm[formData[key]] ?? 0;
      scoreData[key] = freqScore;
      if (Domain === "MH") {
        Total += freqScore;
      }
    });

    const trueCount = mentalHealthoptions.reduce((count, { key }) => {
      return count + (formData[key] ? 1 : 0);
    }, 0);

    // Add 2 if 2 or more are true
    if (trueCount >= 2) {
      if (Domain === "MH") {
        Total += 2;
      }
    }

    physicalHealthOptions.forEach(({ key }) => {
      scoreData[key] = formData[key] ? 0.01 : 0; // Keep as float for response options
    });

    const frequencyMapGroupp1 = {
      "5+x Week": 4,
      "3-4x Week": 3,
      "1-2x Week": 2,
      "1-2x Month": 1,
      "N/A-Rare": 0,
      "No Answer": 0,
      "": 0,
      null: 0,
      undefined: 0,
    };

    const frequencyMapGroupp3 = {
      "5+x Week": 4,
      "3-4x Week": 0.03,
      "1-2x Week": 0.02,
      "1-2x Month": 0.01,
      "N/A-Rare": 0,
      "No Answer": 0,
      "": 0,
      null: 0,
      undefined: 0,
    };
    const frequencyMapGroupp4 = {
      "5+x Week": 0,
      "3-4x Week": 1,
      "1-2x Week": 2,
      "1-2x Month": 3,
      "N/A-Rare": 4,
      "No Answer": 0,
      "": 0,
      null: 0,
      undefined: 0,
    };

    // First 2 items (Vegetables and Beans)
    physicalHealth.slice(0, 2).forEach(({ key }) => {
      const freqScore = frequencyMapGroupp4[formData[key]] ?? 0;
      scoreData[key] = freqScore;
      if (Domain === "PH") {
        Total += freqScore;
      }
    });

    // Next 2 items (Grains and Dairy) are informational only.
    physicalHealth.slice(2, 4).forEach(({ key }) => {
      scoreData[key] = 0;
    });

    // Next 2 items (Meat and Fish)
    physicalHealth.slice(4, 6).forEach(({ key }) => {
      const freqScore = frequencyMapGroupp3[formData[key]] ?? 0;
      scoreData[key] = freqScore;
      if (Domain === "PH" && freqScore >= 1) {
        Total += freqScore;
      }
    });

    // Next 1 item (Sugar and Sweets)
    physicalHealth.slice(6, 7).forEach(({ key }) => {
      const freqScore = frequencyMapGroupp1[formData[key]] ?? 0;
      scoreData[key] = freqScore;
    });

    // Last 2 items (Water and Physical Activity)
    physicalHealth.slice(7, 9).forEach(({ key }) => {
      const freqScore = frequencyMapGroupp4[formData[key]] ?? 0;
      scoreData[key] = freqScore;
    });
    physicalHealth.slice(6, 7).forEach(({ key }) => {
      const freqScore = frequencyMapGroupp1[formData[key]] ?? 0;
      scoreData[key] = freqScore;
      if (Domain === "PH") {
        Total += freqScore;
      }
    });
    physicalHealth.slice(7, 9).forEach(({ key }) => {
      const freqScore = frequencyMapGroupp4[formData[key]] ?? 0;
      scoreData[key] = freqScore;
      if (Domain === "PH") {
        Total += freqScore;
      }
    });

    const trueCountPhysical = physicalHealthOptions.reduce((count, { key }) => {
      return count + (formData[key] ? 1 : 0);
    }, 0);

    // Add 2 if 2 or more are true
    if (trueCountPhysical >= 2) {
      if (Domain === "PH") {
        Total += 2;
      }
    }
    const frequencyMapGroups1 = {
      "5+x Week": 0,
      "3-4x Week": 1,
      "1-2x Week": 2,
      "1-2x Month": 3,
      "N/A-Rare": 4,
      "No Answer": 0,
      "": 0,
      null: 0,
      undefined: 0,
    };
    const frequencyMapGroups2 = {
      "Strongly Agree": 0,
      Agree: 1,
      Neither: 2,
      Disagree: 3,
      "Strongly Disagree": 4,
      "No Answer": 0,
      "": 0,
      null: 0,
      undefined: 0,
    };

    spiritualHealthOptions.slice(0, 2).forEach(({ key }) => {
      const freqScore = frequencyMapGroups2[formData[key]] ?? 0;
      scoreData[key] = freqScore;
      if (Domain === "SH") {
        Total += freqScore;
      }
    });

    spiritualHealthOptions.slice(2).forEach(({ key }) => {
      const freqScore = frequencyMapGroups1[formData[key]] ?? 0;
      scoreData[key] = freqScore;
      if (Domain === "SH") {
        Total += freqScore;
      }
    });

    const frequencyMapGroupo1 = {
      "5+x Week": 4,
      "3-4x Week": 3,
      "1-2x Week": 2,
      "1-2x Month": 1,
      "N/A-Rare": 0,
      "No Answer": 0,
      "": 0,
      null: 0,
      undefined: 0,
    };
    const frequencyMapGroupo2 = {
      "5+x Week": 0,
      "3-4x Week": 1,
      "1-2x Week": 2,
      "1-2x Month": 3,
      "N/A-Rare": 4,
      "No Answer": 0,
      "": 0,
      null: 0,
      undefined: 0,
    };
    socialhealth.forEach(({ key }) => {
      const frequencyMap =
        key === "SoHEUnpleasant" ? frequencyMapGroupo1 : frequencyMapGroupo2;
      const freqScore = frequencyMap[formData[key]] ?? 0;
      scoreData[key] = freqScore;
      if (Domain === "SoH") {
        Total += freqScore;
      }
    });

    if (Domain === "TR") {
      scoreData.TRScore = String(Number.isFinite(Total) ? Total : 0);
    }
    if (Domain === "CM") {
      scoreData.CMScore = String(Total);
    }
    if (Domain === "MH") {
      scoreData.MHScore = String(Total);
    }
    if (Domain === "PH") {
      scoreData.PHScore = String(Total);
    }
    if (Domain === "SH") {
      scoreData.SHScore = String(Total);
    }
    if (Domain === "SoH") {
      scoreData.SoHScore = String(Total);
    }

    return scoreData;
  }

  function buildAssessmentScoreInput({
    userId,
    organizationId,
    completedDate,
    completedTime,
    isActive,
    domain,
    formData,
    input,
    id,
    includeAllFields = false,
  }) {
    const rawScores = includeAllFields
      ? mergeScoreDefaults(calculateScores6(formData, domain))
      : calculateScores6(formData, domain);
    const sectionKeys = assessmentScoreKeysBySection[domain] || [];
    const selectedScores = includeAllFields
      ? rawScores
      : Object.fromEntries(
          Object.entries(rawScores).filter(([key]) =>
            sectionKeys.includes(key),
          ),
        );

    return filterToAllowed(
      mapToLegacyAssessmentFieldNames({
        ...(id ? { id } : {}),
        userId,
        ...(organizationId ? { organizationId } : {}),
        CompletedDate: completedDate,
        CompletedTime: completedTime,
        isActive,
        ...selectedScores,
        SDoHAgeRange: input?.SDoHAgeRange,
        SDoHRace: input?.SDoHRace,
        SDoHGeographicRegion: input?.SDoHGeographicRegion,
        SDoHEthnicity: input?.SDoHEthnicity,
        SDoHState: input?.SDoHState,
        SDoHZipCode: input?.SDoHZipCode,
        SDoHMaritalStatus: input?.SDoHMaritalStatus,
        SDoHMilitaryStatus: input?.SDoHMilitaryStatus,
        SDoHGender: input?.SDoHGender,
        SDoHEducation: input?.SDoHEducation,
        SDoHJobStatus: input?.SDoHJobStatus,
        SDoHIncome: input?.SDoHIncome,
        SDoHHousingStatus: input?.SDoHHousingStatus,
        SDoHHomeAsChild: input?.SDoHHomeAsChild,
        SDoHReligion: input?.SDoHReligion,
        SDoHDenomination: input?.SDoHDenomination,
      }),
    );
  }

  function buildAssessmentAnswersInput(
    input,
    id,
    section,
    includeAllFields = false,
  ) {
    const sectionKeys = assessmentAnswerKeysBySection[section] || [];
    const selectedInput = includeAllFields
      ? input
      : Object.fromEntries(
          Object.entries(input).filter(([key]) => sectionKeys.includes(key)),
        );

    return mapToLegacyAssessmentFieldNames({
      ...selectedInput,
      ...(id ? { id } : {}),
    });
  }

  const toggleBoolean = (key) =>
    setFormData((prev) => ({ ...prev, [key]: !prev[key] }));

  const setTraumaBelief = (key) =>
    setFormData((prev) => ({
      ...prev,
      TRBelief: key === "Yes" ? true : key === "No" ? false : undefined,
      traumaBeliefKey: key,
    }));

  const toggleTraumaResponse = (key) => {
    if (key === "TRNoTrauma") {
      const isSelected = !!formData[key];
      const cleared = {};
      traumaResponseOptions.forEach(({ key }) => (cleared[key] = false));
      if (!isSelected) cleared[key] = true;
      setFormData((prev) => ({ ...prev, ...cleared }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [key]: !prev[key],
        TRNoTrauma: false,
      }));
    }
  };
  const handleInputChange = (key, value) =>
    setFormData((prev) => ({ ...prev, [key]: value }));

  const handleCopingChange = (key, value) =>
    setFormData((prev) => ({ ...prev, [key]: value }));

  const handleTraumaNext = async () => {
    if (isAssessmentRequired) {
      const traumaSelected = traumaExperiences.some(({ key }) => formData[key]);
      const traumaBelief = formData.traumaBeliefKey;
      const traumaResponseSelected = traumaResponseOptions.some(
        ({ key }) => formData[key],
      );

      // Reset warning first
      setTraumaWarning("");

      if (!traumaBelief) {
        setTraumaWarning(
          "Please select one option for the second question regarding whether you consider your experience traumatic.",
        );
        return;
      }

      if (!traumaResponseSelected) {
        setTraumaWarning(
          "Please select at least one statement from the third question regarding your trauma response.",
        );
        return;
      }

      if (traumaBelief !== "NA" && !traumaSelected) {
        setTraumaWarning(
          "Since you did not select 'N/A' for the second question, please select at least one experience from the first question.",
        );
        return;
      }
    }

    // Proceed with submitting or navigating
    setTimeout(() => {
      // example async or navigation delay

      setTraumaWarning("");
    }, 10000);

    // navigate to next page immediately so the user sees it while save runs
    setStep("coping");
    setIsSubmitting(true);
    try {
      const input = {
        userId,
        ...(organizationId ? { organizationId } : {}),
        CompletedDate: new Date().toISOString().slice(0, 10),
        CompletedTime: new Date().toLocaleTimeString(),
        isActive: true,
      };

      traumaExperiences.forEach(({ key }) => {
        input[key] =
          formData[key] !== undefined ? !!formData[key] : (input[key] ?? false);
      });
      traumaResponseOptions.forEach(({ key }) => {
        input[key] =
          formData[key] !== undefined ? !!formData[key] : (input[key] ?? false);
      });
      input["TRBelief"] =
        formData["TRBelief"] !== undefined
          ? formData["TRBelief"]
          : (input["TRBelief"] ?? false);

      copingMechanisms.forEach(({ key }) => {
        const value = formData[key];
        if (value === "" || value === undefined || value === null) {
          input[key] = "No Answer";
        } else {
          input[key] = value;
        }
      });
      mentalHealthoptions.forEach(({ key }) => {
        input[key] =
          formData[key] !== undefined ? !!formData[key] : (input[key] ?? false);
      });
      mentalHealth.forEach(({ key }) => {
        const value = formData[key];
        if (value === "" || value === undefined || value === null) {
          input[key] = "No Answer";
        } else {
          input[key] = value;
        }
      });
      physicalHealthOptions.forEach(({ key }) => {
        input[key] =
          formData[key] !== undefined ? !!formData[key] : (input[key] ?? false);
      });
      physicalHealth.forEach(({ key }) => {
        const value = formData[key];
        if (value === "" || value === undefined || value === null) {
          input[key] = "No Answer";
        } else {
          input[key] = value;
        }
      });
      spiritualHealthOptions.forEach(({ key }) => {
        const value = formData[key];
        if (value === "" || value === undefined || value === null) {
          input[key] = "No Answer";
        } else {
          input[key] = value;
        }
      });
      socialhealth.forEach(({ key }) => {
        const value = formData[key];
        if (value === "" || value === undefined || value === null) {
          input[key] = "No Answer";
        } else {
          input[key] = value;
        }
      });

      // Only run mergeDefaults when it's a new record (and allow SDoH keys to be included)
      if (!existingRecordId) {
        mergeDefaults(input);
      }

      if (existingRecordId) {
        throwIfGraphqlErrors(
          await client.graphql({
            query: updateAssessmentAnswersMutation,
            variables: {
              input: buildAssessmentAnswersInput(
                input,
                existingRecordId,
                "trauma",
              ),
            },
          }),
          "Failed to update assessment answers during trauma step",
        );
      } else {
        const res = throwIfGraphqlErrors(
          await client.graphql({
            query: createAssessmentAnswersMutation,
            variables: {
              input: buildAssessmentAnswersInput(
                input,
                undefined,
                "trauma",
                true,
              ),
            },
          }),
          "Failed to create assessment answers during trauma step",
        );
        setExistingRecordId(res.data.createAssessmentAnswers.id);
      }

      const scoreInput = buildAssessmentScoreInput({
        userId,
        organizationId,
        completedDate: input.CompletedDate,
        completedTime: input.CompletedTime,
        isActive: true,
        domain: "TR",
        formData,
        input,
        includeAllFields: false,
      });

      // Debug: log outgoing score payload keys to catch schema mismatches
      try {
        console.debug(
          "handleSocialSubmit - scoreInput keys:",
          Object.keys(scoreInput),
        );
        console.debug("handleSocialSubmit - scoreInput preview:", {
          SoHScore: scoreInput.SoHScore,
          SoHContribution: scoreInput.SoHContribution,
        });

        if (existingScoreId) {
          const res = await client.graphql({
            query: updateAssessmentScoresMutation,
            variables: { input: { ...scoreInput, id: existingScoreId } },
          });
          if (res?.errors) console.error("GraphQL update errors:", res.errors);
        } else {
          const res = await client.graphql({
            query: createAssessmentScoresMutation,
            variables: { input: scoreInput },
          });
          if (res?.errors) console.error("GraphQL create errors:", res.errors);
          setExistingScoreId(
            res.data?.createAssessmentScores?.id || existingScoreId,
          );
        }
      } catch (e) {
        console.error("GraphQL error submitting social scores:", e);
        throw e;
      }

      // navigation already performed
    } catch (err) {
      console.error("Error submitting trauma:", err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCopingSubmit = async () => {
    if (isAssessmentRequired) {
      const allAnswered = copingMechanisms.every(({ key }) => {
        return formData[key] && formData[key] !== "No Answer";
      });

      if (!allAnswered) {
        const unanswered = copingMechanisms
          .filter(({ key }) => !formData[key] || formData[key] === "No Answer")
          .map(({ key }) => key);
        setUnansweredCopingFields(unanswered);
        setCopingWarning(true); // Show warning
        return; // Don't proceed
      }
    }

    setUnansweredCopingFields([]);
    setCopingWarning(false); // Clear warning if all answered
    // navigate immediately so UI shows next section while saving
    setStep("mental");
    setIsSubmitting(true);
    try {
      const input = {
        id: existingRecordId,
        userId,
        ...(organizationId ? { organizationId } : {}),
        CompletedDate: new Date().toISOString().slice(0, 10),
        CompletedTime: new Date().toLocaleTimeString(),
        isActive: true,
      };

      traumaExperiences.forEach(({ key }) => {
        input[key] =
          formData[key] !== undefined ? !!formData[key] : (input[key] ?? false);
      });
      traumaResponseOptions.forEach(({ key }) => {
        input[key] =
          formData[key] !== undefined ? !!formData[key] : (input[key] ?? false);
      });
      input["TRBelief"] =
        formData["TRBelief"] !== undefined
          ? formData["TRBelief"]
          : (input["TRBelief"] ?? false);

      copingMechanisms.forEach(({ key }) => {
        const value = formData[key];
        if (value === "" || value === undefined || value === null) {
          input[key] = "No Answer";
        } else {
          input[key] = value;
        }
      });
      mentalHealthoptions.forEach(({ key }) => {
        input[key] =
          formData[key] !== undefined ? !!formData[key] : (input[key] ?? false);
      });
      mentalHealth.forEach(({ key }) => {
        const value = formData[key];
        if (value === "" || value === undefined || value === null) {
          input[key] = "No Answer";
        } else {
          input[key] = value;
        }
      });
      physicalHealthOptions.forEach(({ key }) => {
        input[key] =
          formData[key] !== undefined ? !!formData[key] : (input[key] ?? false);
      });
      physicalHealth.forEach(({ key }) => {
        const value = formData[key];
        if (value === "" || value === undefined || value === null) {
          input[key] = "No Answer";
        } else {
          input[key] = value;
        }
      });
      spiritualHealthOptions.forEach(({ key }) => {
        const value = formData[key];
        if (value === "" || value === undefined || value === null) {
          input[key] = "No Answer";
        } else {
          input[key] = value;
        }
      });
      socialhealth.forEach(({ key }) => {
        const value = formData[key];
        if (value === "" || value === undefined || value === null) {
          input[key] = "No Answer";
        } else {
          input[key] = value;
        }
      });

      if (!existingRecordId) {
        mergeDefaults(input);
      }

      if (existingRecordId) {
        throwIfGraphqlErrors(
          await client.graphql({
            query: updateAssessmentAnswersMutation,
            variables: {
              input: buildAssessmentAnswersInput(
                input,
                existingRecordId,
                "coping",
              ),
            },
          }),
          "Failed to update assessment answers during coping step",
        );
      }

      const scoreInput = buildAssessmentScoreInput({
        userId,
        organizationId,
        completedDate: input.CompletedDate,
        completedTime: input.CompletedTime,
        isActive: true,
        domain: "CM",
        formData,
        input,
        includeAllFields: false,
      });

      // Debug: log outgoing score payload keys to catch schema mismatches
      try {
        console.debug(
          "handleSocialSubmit - scoreInput keys:",
          Object.keys(scoreInput),
        );
        console.debug("handleSocialSubmit - scoreInput preview:", {
          SoHScore: scoreInput.SoHScore,
          SoHContribution: scoreInput.SoHContribution,
        });

        if (existingScoreId) {
          const variables = { input: { ...scoreInput, id: existingScoreId } };
          console.debug("handleSocialSubmit - variables:", variables);
          const res = await client.graphql({
            query: updateAssessmentScoresMutation,
            variables,
          });
          if (res?.errors) console.error("GraphQL update errors:", res.errors);
          else console.debug("GraphQL update response:", res);
        } else {
          const variables = { input: scoreInput };
          console.debug("handleSocialSubmit - variables:", variables);
          const res = await client.graphql({
            query: createAssessmentScoresMutation,
            variables,
          });
          if (res?.errors) console.error("GraphQL create errors:", res.errors);
          else console.debug("GraphQL create response:", res);
          setExistingScoreId(res.data.createAssessmentScores.id);
        }
      } catch (e) {
        console.error("GraphQL error submitting social scores:", e);
        // Re-throw so outer catch logs the same error path
        throw e;
      }

      // navigation already performed
    } catch (err) {
      console.error("Error submitting coping:", err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleMentalSubmit = async () => {
    if (isAssessmentRequired) {
      const allFilled = mentalHealth.every(
        ({ key }) => formData[key] && formData[key] !== "No Answer",
      );

      if (!allFilled) {
        const unanswered = mentalHealth
          .filter(({ key }) => !formData[key] || formData[key] === "No Answer")
          .map(({ key }) => key);
        setUnansweredMentalFields(unanswered);
        setMentalWarning("Please answer all dropdown questions to move on.");
        return;
      }
    }
    setUnansweredMentalFields([]);

    // Proceed with saving or navigating
    setMentalWarning("");

    // Navigate immediately so user sees next page while save runs
    setStep("physical");
    setIsSubmitting(true);
    try {
      const input = {
        id: existingRecordId,
        userId,
        ...(organizationId ? { organizationId } : {}),
        CompletedDate: new Date().toISOString().slice(0, 10),
        CompletedTime: new Date().toLocaleTimeString(),
        isActive: true,
      };

      traumaExperiences.forEach(({ key }) => {
        input[key] =
          formData[key] !== undefined ? !!formData[key] : (input[key] ?? false);
      });
      traumaResponseOptions.forEach(({ key }) => {
        input[key] =
          formData[key] !== undefined ? !!formData[key] : (input[key] ?? false);
      });
      input["TRBelief"] =
        formData["TRBelief"] !== undefined
          ? formData["TRBelief"]
          : (input["TRBelief"] ?? false);

      copingMechanisms.forEach(({ key }) => {
        const value = formData[key];
        if (value === "" || value === undefined || value === null) {
          input[key] = "No Answer";
        } else {
          input[key] = value;
        }
      });
      mentalHealthoptions.forEach(({ key }) => {
        input[key] =
          formData[key] !== undefined ? !!formData[key] : (input[key] ?? false);
      });
      mentalHealth.forEach(({ key }) => {
        const value = formData[key];
        if (value === "" || value === undefined || value === null) {
          input[key] = "No Answer";
        } else {
          input[key] = value;
        }
      });
      physicalHealthOptions.forEach(({ key }) => {
        input[key] =
          formData[key] !== undefined ? !!formData[key] : (input[key] ?? false);
      });
      physicalHealth.forEach(({ key }) => {
        const value = formData[key];
        if (value === "" || value === undefined || value === null) {
          input[key] = "No Answer";
        } else {
          input[key] = value;
        }
      });
      spiritualHealthOptions.forEach(({ key }) => {
        const value = formData[key];
        if (value === "" || value === undefined || value === null) {
          input[key] = "No Answer";
        } else {
          input[key] = value;
        }
      });
      socialhealth.forEach(({ key }) => {
        const value = formData[key];
        if (value === "" || value === undefined || value === null) {
          input[key] = "No Answer";
        } else {
          input[key] = value;
        }
      });

      if (!existingRecordId) {
        mergeDefaults(input);
      }

      if (existingRecordId) {
        throwIfGraphqlErrors(
          await client.graphql({
            query: updateAssessmentAnswersMutation,
            variables: {
              input: buildAssessmentAnswersInput(
                input,
                existingRecordId,
                "mental",
              ),
            },
          }),
          "Failed to update assessment answers during mental step",
        );
      }

      const scoreInput = buildAssessmentScoreInput({
        userId,
        organizationId,
        completedDate: input.CompletedDate,
        completedTime: input.CompletedTime,
        isActive: true,
        domain: "MH",
        formData,
        input,
        includeAllFields: false,
      });

      if (existingScoreId) {
        await client.graphql({
          query: updateAssessmentScoresMutation,
          variables: { input: { ...scoreInput, id: existingScoreId } },
        });
      } else {
        const res = await client.graphql({
          query: createAssessmentScoresMutation,
          variables: { input: scoreInput },
        });
        setExistingScoreId(res.data.createAssessmentScores.id);
      }

      // navigation already performed
    } catch (err) {
      console.error("Error submitting mental:", err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handlePhysicalSubmit = async () => {
    if (isAssessmentRequired) {
      const allFilled = physicalHealth.every(
        ({ key }) => formData[key] && formData[key] !== "No Answer",
      );

      if (!allFilled) {
        const unanswered = physicalHealth
          .filter(({ key }) => !formData[key] || formData[key] === "No Answer")
          .map(({ key }) => key);
        setUnansweredPhysicalFields(unanswered);
        setPhysicalWarning("Please answer all dropdown questions to move on.");
        return;
      }
    }
    setUnansweredPhysicalFields([]);

    // Proceed with saving or navigating
    setPhysicalWarning("");
    // navigate immediately so the user sees the next section while save runs
    setStep("spiritual");
    setIsSubmitting(true);
    try {
      const input = {
        id: existingRecordId,
        userId,
        ...(organizationId ? { organizationId } : {}),
        CompletedDate: new Date().toISOString().slice(0, 10),
        CompletedTime: new Date().toLocaleTimeString(),
        isActive: true,
      };

      traumaExperiences.forEach(({ key }) => {
        input[key] =
          formData[key] !== undefined ? !!formData[key] : (input[key] ?? false);
      });
      traumaResponseOptions.forEach(({ key }) => {
        input[key] =
          formData[key] !== undefined ? !!formData[key] : (input[key] ?? false);
      });
      input["TRBelief"] =
        formData["TRBelief"] !== undefined
          ? formData["TRBelief"]
          : (input["TRBelief"] ?? false);

      copingMechanisms.forEach(({ key }) => {
        const value = formData[key];
        if (value === "" || value === undefined || value === null) {
          input[key] = "No Answer";
        } else {
          input[key] = value;
        }
      });
      mentalHealthoptions.forEach(({ key }) => {
        input[key] =
          formData[key] !== undefined ? !!formData[key] : (input[key] ?? false);
      });
      mentalHealth.forEach(({ key }) => {
        const value = formData[key];
        if (value === "" || value === undefined || value === null) {
          input[key] = "No Answer";
        } else {
          input[key] = value;
        }
      });
      physicalHealthOptions.forEach(({ key }) => {
        input[key] =
          formData[key] !== undefined ? !!formData[key] : (input[key] ?? false);
      });
      physicalHealth.forEach(({ key }) => {
        const value = formData[key];
        if (value === "" || value === undefined || value === null) {
          input[key] = "No Answer";
        } else {
          input[key] = value;
        }
      });
      spiritualHealthOptions.forEach(({ key }) => {
        const value = formData[key];
        if (value === "" || value === undefined || value === null) {
          input[key] = "No Answer";
        } else {
          input[key] = value;
        }
      });
      socialhealth.forEach(({ key }) => {
        const value = formData[key];
        if (value === "" || value === undefined || value === null) {
          input[key] = "No Answer";
        } else {
          input[key] = value;
        }
      });

      if (!existingRecordId) {
        mergeDefaults(input);
      }

      if (existingRecordId) {
        throwIfGraphqlErrors(
          await client.graphql({
            query: updateAssessmentAnswersMutation,
            variables: {
              input: buildAssessmentAnswersInput(
                input,
                existingRecordId,
                "physical",
              ),
            },
          }),
          "Failed to update assessment answers during physical step",
        );
      }

      const scoreInput = buildAssessmentScoreInput({
        userId,
        organizationId,
        completedDate: input.CompletedDate,
        completedTime: input.CompletedTime,
        isActive: true,
        domain: "PH",
        formData,
        input,
        includeAllFields: false,
      });

      if (existingScoreId) {
        await client.graphql({
          query: updateAssessmentScoresMutation,
          variables: { input: { ...scoreInput, id: existingScoreId } },
        });
      } else {
        const res = await client.graphql({
          query: createAssessmentScoresMutation,
          variables: { input: scoreInput },
        });
        setExistingScoreId(res.data.createAssessmentScores.id);
      }

      setStep("spiritual");
    } catch (err) {
      console.error("Error submitting physical:", err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSpiritualSubmit = async () => {
    // Spiritual health is mandatory if they reach this screen
    const allFilled = spiritualHealthOptions.every(
      ({ key }) => formData[key] && formData[key] !== "No Answer",
    );

    if (!allFilled) {
      const unanswered = spiritualHealthOptions
        .filter(({ key }) => !formData[key] || formData[key] === "No Answer")
        .map(({ key }) => key);
      setUnansweredSpiritualFields(unanswered);
      setSpiritualWarning("Please answer all dropdown questions to move on.");
      return;
    }

    // All questions answered - proceed
    setSpiritualWarning("");
    setUnansweredSpiritualFields([]);
    // navigate immediately so the user sees the next section while save runs
    setStep("social");
    setIsSubmitting(true);
    try {
      const input = {
        id: existingRecordId,
        userId,
        ...(organizationId ? { organizationId } : {}),
        CompletedDate: new Date().toISOString().slice(0, 10),
        CompletedTime: new Date().toLocaleTimeString(),
        isActive: true,
      };

      traumaExperiences.forEach(({ key }) => {
        input[key] =
          formData[key] !== undefined ? !!formData[key] : (input[key] ?? false);
      });
      traumaResponseOptions.forEach(({ key }) => {
        input[key] =
          formData[key] !== undefined ? !!formData[key] : (input[key] ?? false);
      });
      input["TRBelief"] =
        formData["TRBelief"] !== undefined
          ? formData["TRBelief"]
          : (input["TRBelief"] ?? false);

      copingMechanisms.forEach(({ key }) => {
        const value = formData[key];
        if (value === "" || value === undefined || value === null) {
          input[key] = "No Answer";
        } else {
          input[key] = value;
        }
      });
      mentalHealthoptions.forEach(({ key }) => {
        input[key] =
          formData[key] !== undefined ? !!formData[key] : (input[key] ?? false);
      });
      mentalHealth.forEach(({ key }) => {
        const value = formData[key];
        if (value === "" || value === undefined || value === null) {
          input[key] = "No Answer";
        } else {
          input[key] = value;
        }
      });
      physicalHealthOptions.forEach(({ key }) => {
        input[key] =
          formData[key] !== undefined ? !!formData[key] : (input[key] ?? false);
      });
      physicalHealth.forEach(({ key }) => {
        const value = formData[key];
        if (value === "" || value === undefined || value === null) {
          input[key] = "No Answer";
        } else {
          input[key] = value;
        }
      });
      spiritualHealthOptions.forEach(({ key }) => {
        const value = formData[key];
        if (value === "" || value === undefined || value === null) {
          input[key] = "No Answer";
        } else {
          input[key] = value;
        }
      });
      socialhealth.forEach(({ key }) => {
        const value = formData[key];
        if (value === "" || value === undefined || value === null) {
          input[key] = "No Answer";
        } else {
          input[key] = value;
        }
      });

      if (!existingRecordId) {
        mergeDefaults(input);
      }

      if (existingRecordId) {
        throwIfGraphqlErrors(
          await client.graphql({
            query: updateAssessmentAnswersMutation,
            variables: {
              input: buildAssessmentAnswersInput(
                input,
                existingRecordId,
                "spiritual",
              ),
            },
          }),
          "Failed to update assessment answers during spiritual step",
        );
      }

      const scoreInput = buildAssessmentScoreInput({
        userId,
        organizationId,
        completedDate: input.CompletedDate,
        completedTime: input.CompletedTime,
        isActive: true,
        domain: "SH",
        formData,
        input,
        includeAllFields: false,
      });

      if (existingScoreId) {
        await client.graphql({
          query: updateAssessmentScoresMutation,
          variables: { input: { ...scoreInput, id: existingScoreId } },
        });
      } else {
        const res = await client.graphql({
          query: createAssessmentScoresMutation,
          variables: { input: scoreInput },
        });
        setExistingScoreId(res.data.createAssessmentScores.id);
      }

      setStep("social");
    } catch (err) {
      console.error("Error submitting spiritual:", err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSocialSubmit = async () => {
    if (isAssessmentRequired) {
      const allFilled = socialhealth.every(
        ({ key }) =>
          formData[key] &&
          formData[key] !== "No Answer" &&
          formData[key] !== "" &&
          formData[key] !== "Select",
      );

      if (!allFilled) {
        const unanswered = socialhealth
          .filter(
            ({ key }) =>
              !formData[key] ||
              formData[key] === "No Answer" ||
              formData[key] === "" ||
              formData[key] === "Select",
          )
          .map(({ key }) => key);
        setUnansweredSocialFields(unanswered);
        setSocialWarning("Please answer all dropdown questions to move on.");
        return;
      }
    }

    // Proceed with saving or navigating
    setUnansweredSocialFields([]);
    setSocialWarning("");
    // navigate immediately so the user sees the next section while save runs
    setStep("SDOH");
    setIsSubmitting(true);
    try {
      const input = {
        id: existingRecordId,
        userId,
        ...(organizationId ? { organizationId } : {}),
        CompletedDate: new Date().toISOString().slice(0, 10),
        CompletedTime: new Date().toLocaleTimeString(),
        isActive: true,
      };

      traumaExperiences.forEach(({ key }) => {
        input[key] =
          formData[key] !== undefined ? !!formData[key] : (input[key] ?? false);
      });
      traumaResponseOptions.forEach(({ key }) => {
        input[key] =
          formData[key] !== undefined ? !!formData[key] : (input[key] ?? false);
      });
      input["TRBelief"] =
        formData["TRBelief"] !== undefined
          ? formData["TRBelief"]
          : (input["TRBelief"] ?? false);

      copingMechanisms.forEach(({ key }) => {
        const value = formData[key];
        if (value === "" || value === undefined || value === null) {
          input[key] = "No Answer";
        } else {
          input[key] = value;
        }
      });
      mentalHealthoptions.forEach(({ key }) => {
        input[key] =
          formData[key] !== undefined ? !!formData[key] : (input[key] ?? false);
      });
      mentalHealth.forEach(({ key }) => {
        const value = formData[key];
        if (value === "" || value === undefined || value === null) {
          input[key] = "No Answer";
        } else {
          input[key] = value;
        }
      });
      physicalHealthOptions.forEach(({ key }) => {
        input[key] =
          formData[key] !== undefined ? !!formData[key] : (input[key] ?? false);
      });
      physicalHealth.forEach(({ key }) => {
        const value = formData[key];
        if (value === "" || value === undefined || value === null) {
          input[key] = "No Answer";
        } else {
          input[key] = value;
        }
      });
      spiritualHealthOptions.forEach(({ key }) => {
        const value = formData[key];
        if (value === "" || value === undefined || value === null) {
          input[key] = "No Answer";
        } else {
          input[key] = value;
        }
      });
      socialhealth.forEach(({ key }) => {
        const value = formData[key];
        if (value === "" || value === undefined || value === null) {
          input[key] = "No Answer";
        } else {
          input[key] = value;
        }
      });

      if (!existingRecordId) {
        mergeDefaults(input);
      }

      if (existingRecordId) {
        throwIfGraphqlErrors(
          await client.graphql({
            query: updateAssessmentAnswersMutation,
            variables: {
              input: buildAssessmentAnswersInput(
                input,
                existingRecordId,
                "social",
              ),
            },
          }),
          "Failed to update assessment answers during social step",
        );
      }

      const scoreInput = buildAssessmentScoreInput({
        userId,
        organizationId,
        completedDate: input.CompletedDate,
        completedTime: input.CompletedTime,
        isActive: true,
        domain: "SoH",
        formData,
        input,
        includeAllFields: false,
      });

      if (existingScoreId) {
        throwIfGraphqlErrors(
          await client.graphql({
            query: updateAssessmentScoresMutation,
            variables: { input: { ...scoreInput, id: existingScoreId } },
          }),
          "Failed to update assessment scores during social step",
        );
      } else {
        const res = throwIfGraphqlErrors(
          await client.graphql({
            query: createAssessmentScoresMutation,
            variables: { input: scoreInput },
          }),
          "Failed to create assessment scores during social step",
        );
        setExistingScoreId(res.data.createAssessmentScores.id);
      }

      setStep("SDOH");
    } catch (err) {
      console.error("Error submitting social:", err);
      setSocialWarning(
        getErrorMessage(
          err,
          "Failed to save the Social Health section. Please try again.",
        ),
      );
      setStep("social");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSDOHSubmit = async (createNew = false) => {
    if (!userId) {
      console.error("Missing user ID");
      setSdohWarning("Your user session is not ready yet. Please try again.");
      return;
    }
    if (isAssessmentRequired) {
      try {
        const validationSnapshot = { ...schemaDefaults, ...formData };
        const failedSections = validateAssessmentData(validationSnapshot);

        if (failedSections.length > 0) {
          showIncompleteSectionWarning(failedSections[0]);
          return;
        }

        // ✅ All good
        setSdohWarning("");
        // continue to next step or complete assessment
      } catch (err) {
        console.error("Validation error:", err);
        setSdohWarning(
          err?.message || "There was an error validating your data.",
        );
        return;
      }
    }

    // ✅ Clear warning and proceed to submit
    setSdohWarning("");

    setIsSubmitting(true);

    try {
      const attrs = await fetchUserAttributes();
      const currentUserId = attrs?.sub || userId;

      const [answersLookupRes, scoresLookupRes] = await Promise.all([
        client.graphql({
          query: listActiveAssessmentAnswerIdsQuery,
          variables: {
            filter: {
              or: [
                { userId: { eq: currentUserId } },
                { owner: { eq: currentUserId } },
              ],
              isActive: { eq: true },
            },
            limit: 100,
          },
        }),
        client.graphql({
          query: listActiveAssessmentScoreIdsQuery,
          variables: {
            filter: {
              or: [
                { userId: { eq: currentUserId } },
                { owner: { eq: currentUserId } },
              ],
              isActive: { eq: true },
            },
            limit: 100,
          },
        }),
      ]);

      throwIfGraphqlErrors(
        answersLookupRes,
        "Failed to load active assessment answers",
      );
      throwIfGraphqlErrors(
        scoresLookupRes,
        "Failed to load active assessment scores",
      );

      const activeAnswerItems =
        answersLookupRes?.data?.listAssessmentAnswers?.items || [];
      const activeScoreItems =
        scoresLookupRes?.data?.listAssessmentScores?.items || [];

      const resolvedRecord = [...activeAnswerItems].sort(
        (a, b) =>
          new Date(b?.updatedAt || b?.createdAt || 0) -
          new Date(a?.updatedAt || a?.createdAt || 0),
      )[0];
      const resolvedScore = [...activeScoreItems].sort(
        (a, b) =>
          new Date(b?.updatedAt || b?.createdAt || 0) -
          new Date(a?.updatedAt || a?.createdAt || 0),
      )[0];

      const resolvedRecordId = existingRecordId || resolvedRecord?.id;
      const resolvedScoreId = existingScoreId || resolvedScore?.id;

      if (!resolvedRecordId || !resolvedScoreId) {
        setSdohWarning(
          "Could not find the active assessment to finalize. Please go back one step and try again.",
        );
        return;
      }

      const completedDate = new Date().toISOString().slice(0, 10);
      const completedTime = new Date().toLocaleTimeString();
      const normalizeAnswerText = (value, fallback = "No Answer") => {
        if (typeof value === "string") {
          const trimmed = value.trim();
          return trimmed === "" ? fallback : trimmed;
        }
        return value ?? fallback;
      };

      const normalizedSDOH = {
        SDoHAgeRange: normalizeAnswerText(formData.SDoHAgeRange),
        SDoHRace:
          formData.SDoHRace === "Other"
            ? normalizeAnswerText(formData.SDoHRaceCustom, "Other")
            : normalizeAnswerText(formData.SDoHRace),
        SDoHGeographicRegion:
          formData.SDoHGeographicRegion === "Other"
            ? normalizeAnswerText(formData.SDoHGeographicRegionCustom, "Other")
            : normalizeAnswerText(formData.SDoHGeographicRegion),
        SDoHEthnicity:
          formData.SDoHEthnicity === "Other"
            ? normalizeAnswerText(formData.SDoHEthnicityCustom, "Other")
            : normalizeAnswerText(formData.SDoHEthnicity),
        SDoHState: normalizeAnswerText(formData.SDoHState),
        SDoHZipCode: normalizeAnswerText(formData.SDoHZipCode),
        SDoHMaritalStatus: normalizeAnswerText(formData.SDoHMaritalStatus),
        SDoHMilitaryStatus: normalizeAnswerText(formData.SDoHMilitaryStatus),
        SDoHGender:
          formData.SDoHGender === "Other"
            ? normalizeAnswerText(formData.SDoHGenderCustom, "Other")
            : normalizeAnswerText(formData.SDoHGender),
        SDoHEducation: normalizeAnswerText(formData.SDoHEducation),
        SDoHJobStatus: normalizeAnswerText(formData.SDoHJobStatus),
        SDoHIncome: normalizeAnswerText(formData.SDoHIncome),
        SDoHHousingStatus:
          formData.SDoHHousingStatus === "Other"
            ? normalizeAnswerText(formData.SDoHHousingStatusCustom, "Other")
            : normalizeAnswerText(formData.SDoHHousingStatus),
        SDoHHomeAsChild:
          formData.SDoHHomeAsChild === "Other"
            ? normalizeAnswerText(formData.SDoHHomeAsChildCustom, "Other")
            : normalizeAnswerText(formData.SDoHHomeAsChild),
        SDoHReligion:
          formData.SDoHReligion === "Other"
            ? normalizeAnswerText(formData.SDoHReligionCustom, "Other")
            : normalizeAnswerText(formData.SDoHReligion),
        SDoHDenomination:
          formData.SDoHReligion === "Christianity"
            ? normalizeAnswerText(formData.SDoHDenomination)
            : "No Answer",
      };

      const input = {
        id: resolvedRecordId,
        userId: currentUserId,
        ...(organizationId ? { organizationId } : {}),
        CompletedDate: completedDate,
        CompletedTime: completedTime,
        // Final SDoH submit should close the current assessment record.
        isActive: false,
        ...normalizedSDOH,
      };

      // Save the full answers
      throwIfGraphqlErrors(
        await client.graphql({
          query: updateAssessmentAnswersMutation,
          variables: {
            input: buildAssessmentAnswersInput(
              input,
              resolvedRecordId,
              "sdoh",
              true,
            ),
          },
        }),
        "Failed to update assessment answers",
      );

      const scoresInput = buildAssessmentScoreInput({
        id: resolvedScoreId,
        userId: currentUserId,
        organizationId,
        completedDate,
        completedTime,
        isActive: false,
        domain: "",
        formData,
        input: normalizedSDOH,
        // All section scores were already written during prior steps.
        // Final SDoH submit only needs to persist finalization metadata and SDoH fields.
        includeAllFields: false,
      });

      // Save scores
      throwIfGraphqlErrors(
        await client.graphql({
          query: updateAssessmentScoresMutation,
          variables: { input: scoresInput },
        }),
        "Failed to update assessment scores",
      );

      const extraActiveAnswerIds = activeAnswerItems
        .map((item) => item?.id)
        .filter((id) => id && id !== resolvedRecordId);
      const extraActiveScoreIds = activeScoreItems
        .map((item) => item?.id)
        .filter((id) => id && id !== resolvedScoreId);

      if (extraActiveAnswerIds.length || extraActiveScoreIds.length) {
        await Promise.all([
          ...extraActiveAnswerIds.map(async (id) =>
            throwIfGraphqlErrors(
              await client.graphql({
                query: updateAssessmentAnswersMutation,
                variables: { input: { id, isActive: false } },
              }),
              `Failed to archive extra assessment answer ${id}`,
            ),
          ),
          ...extraActiveScoreIds.map(async (id) =>
            throwIfGraphqlErrors(
              await client.graphql({
                query: updateAssessmentScoresMutation,
                variables: { input: { id, isActive: false } },
              }),
              `Failed to archive extra assessment score ${id}`,
            ),
          ),
        ]);
      }

      setSuccessMessage("Social Determinants submitted successfully!");

      // If creating a new assessment after saving:
      if (createNew) {
        setFormData({});
        setExistingRecordId(null);
        setExistingScoreId(null);
        setStep("trauma");
        setSuccessMessage("");
      }

      try {
        const userAttrs = await fetchUserAttributes();

        const userEmail = userAttrs.email;
        // 1. Query UserLink where clientEmail matches
        const userLinksData = await client.graphql({
          query: listUserLinks,
          variables: {
            filter: {
              clientEmail: { eq: userEmail },
            },
          },
        });

        const userLinks = userLinksData.data.listUserLinks.items;

        if (!userLinks.length) {
          console.log("No linked professionals found for this client.");
          // continue to redirect even if there are no linked professionals
        }

        // 2. Extract all professional emails
        const linkedProfessionals = userLinks.map((link) => ({
          email: link.professionalEmail,
          userId: link.professionalId || null,
        }));

        // 3. Loop through each professional to send a notification
        for (const professional of linkedProfessionals) {
          const email = professional.email;
          try {
            // Update original notification status

            const userAttrs = await fetchUserAttributes();
            const responderId = userAttrs.sub;
            const responderFirstName = userAttrs["given_name"] || "";
            const responderLastName = userAttrs["family_name"] || "";
            const responderEmail = String(userAttrs.email || "")
              .trim()
              .toLowerCase();
            // Create RecommendationBack notification
            const newNote = {
              RecommendationNote: `${responderFirstName} ${responderLastName} has an assessment ready for you to reveiw`,

              SenderId: responderId,
              SenderFirstName: responderFirstName,
              SenderLastName: responderLastName,
              SenderEmail: String(userEmail || responderEmail)
                .trim()
                .toLowerCase(),
              TargetEmail: String(email || "")
                .trim()
                .toLowerCase(),
              TargetUserId: professional.userId,
              NotificationType: "ReviewReady",
              Status: "pending",
              StatusDate: new Date().toISOString().split("T")[0],
            };
            console.log("Creating notification:", newNote);

            await client.graphql({
              query: createNotifications,
              variables: { input: newNote },
            });
          } catch (err) {
            console.error("Error responding to recommendation:", err);
          }
          console.log(`Notification sent to ${email}`);
        }
      } catch (error) {
        console.error("Error getting users professionals:", error);
      }
      // Clear local draft then redirect to dashboard after successful submission
      try {
        localStorage.removeItem("assessmentDraft");
      } catch (e) {
        console.warn("Failed to clear assessment draft:", e);
      }
      try {
        if (setCurrentView) {
          setCurrentView("Dashboard");
        } else {
          window.location.href = "/dashboard";
        }
      } catch (e) {
        console.warn("Redirect failed:", e);
      }
    } catch (err) {
      console.error("Failed to submit SDOH:", err);
      setSdohWarning(
        getErrorMessage(
          err,
          "Failed to submit the assessment. Please try again.",
        ),
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  // Shared styles to match glowing blue toggles
  const buttonBaseStyle = {
    minWidth: "100%",
    border: "2px solid",
    borderColor: "#ccc",
    padding: "10px",
    borderRadius: 12,
    background: "#fff",
    cursor: "pointer",
    fontWeight: "normal",
    fontSize: 14,
    textAlign: "center",
    boxShadow: "none",
    transition: "all 0.3s",

    margin: "10px auto",
  };

  const selectedButtonStyle = {
    border: "2px solid",
    borderColor: "#0067B3",
    padding: "10px",
    borderRadius: 12,
    background: "#d9eaff",
    cursor: "pointer",
    fontWeight: "normal",
    fontSize: 14,
    textAlign: "center",
    boxShadow: "0 0 10px #0067B3aa",
    transition: "all 0.3s",
  };

  const selectStyle = {
    minWidth: "100%",
    border: "2px solid",
    borderColor: "#ccc",
    padding: "10px",
    borderRadius: 12,
    background: "#fff",
    cursor: "pointer",
    fontWeight: "normal",
    fontSize: 14,
    textAlign: "center",
    boxShadow: "none",
    transition: "all 0.3s",
  };

  return (
    <div>
      <div
        style={{
          width: 350,
          margin: "0 auto",
          alignItems: "center",
          minWidth: 300,
          backgroundColor: "white",
          padding: 5,
          borderRadius: 12,
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
          color: "#333",
        }}
      >
        <div
          className="assessment-section"
          style={{
            padding: "0 5px",
            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
            color: "#333",
          }}
        >
          <img
            src={(process.env.PUBLIC_URL || "") + "/Icon-WHA-Blue.png"}
            alt="Logo"
            style={{
              width: "100%",
              maxWidth: 200,
              height: "auto",
              display: "block",
              margin: "20px auto 30px auto",
            }}
          />
          <div
            style={{
              textAlign: "center",
              marginBottom: 14,
              marginTop: -80,
            }}
          ></div>
          {step === "trauma" && (
            <div
              className="trauma-box"
              style={{
                padding: 24,
                borderRadius: 16,

                userSelect: "none",
              }}
            >
              <h1 style={{ marginBottom: 16, color: "#333" }}>Trauma</h1>
              <hr style={{ border: "2px solid #ccc", margin: "34px 0" }} />
              <h3 style={{ marginBottom: 16, color: "#0067B3" }}>
                Do you consider yourself to have experienced any of the
                following? (Select all that apply)
              </h3>
              {traumaExperiences.map(({ key, label }) => (
                <button
                  key={key}
                  type="button"
                  className={`trauma-toggle ${formData[key] ? "selected" : ""}`}
                  onClick={() => toggleBoolean(key)}
                  style={{
                    ...buttonBaseStyle,
                    ...(formData[key] ? selectedButtonStyle : {}),
                    textAlign: "center",
                    display: "block",
                  }}
                >
                  {label}
                </button>
              ))}

              <h3 style={{ marginTop: 20, marginBottom: 10, color: "#0067B3" }}>
                For any experiences you chose above, do you consider them to be
                traumatic? (Trauma is defined as "an event, or series of events,
                that causes or caused moderate to severe stress reactions")
              </h3>
              <div style={{ display: "flex", flexWrap: "wrap" }}>
                {considerTraumaOptions.map(({ key, label }) => (
                  <button
                    key={key}
                    type="button"
                    className={`trauma-toggle ${
                      formData.traumaBeliefKey === key ? "selected" : ""
                    }`}
                    onClick={() => setTraumaBelief(key)}
                    style={{
                      ...buttonBaseStyle,

                      padding: "10px 20px",
                      ...(formData.traumaBeliefKey === key
                        ? selectedButtonStyle
                        : {}),
                    }}
                  >
                    {label}
                  </button>
                ))}
              </div>

              <h3 style={{ marginTop: 24, marginBottom: 12, color: "#0067B3" }}>
                Which statements are true regarding the response to your
                traumatic experience(s)? (Select all that apply)
              </h3>
              {traumaResponseOptions.map(({ key, label }) => (
                <button
                  key={key}
                  type="button"
                  className={`trauma-toggle ${formData[key] ? "selected" : ""}`}
                  onClick={() => toggleTraumaResponse(key)}
                  style={{
                    ...buttonBaseStyle,
                    ...(formData[key] ? selectedButtonStyle : {}),
                    textAlign: "center",
                    display: "block",
                  }}
                >
                  {label}
                </button>
              ))}
              <hr style={{ border: "1px solid #ccc", margin: "24px 0" }} />
              <button
                onClick={handleTraumaNext}
                disabled={isSubmitting}
                style={{
                  width: "100%",
                  marginTop: 16,
                  backgroundColor: "#0067B3",
                  color: "white",
                  fontWeight: "700",
                  fontSize: 16,
                  borderRadius: 8,
                  padding: "12px 0",
                  border: "none",
                  cursor: "pointer",
                  userSelect: "none",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                }}
              >
                {isSubmitting ? "Submitting..." : "Next (Coping Mechanisms)"}
              </button>
              {traumaWarning && (
                <div
                  style={{
                    marginTop: 12,
                    color: "#cc0000",
                    fontWeight: "600",
                    fontSize: 14,
                    userSelect: "none",
                  }}
                >
                  {traumaWarning}
                </div>
              )}
            </div>
          )}

          {step === "coping" && (
            <div
              className="trauma-box"
              style={{
                padding: 24,
                borderRadius: 16,

                userSelect: "none",
              }}
            >
              <h1 style={{ marginBottom: 16, color: "#333" }}>
                Coping Mechanisms
              </h1>
              <hr style={{ border: "2px solid #ccc", margin: "34px 0" }} />
              <h3 style={{ marginTop: 24, marginBottom: 12, color: "#0067B3" }}>
                Within the last four weeks, approximately how often did you use
                the following coping mechanisms to deal with unpleasant
                experiences?
              </h3>
              {copingMechanisms.map(({ key, label }) => (
                <div
                  key={key}
                  className="coping-collumn"
                  style={{
                    marginBottom: 16,
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column", // <-- vertical layout
                    padding: unansweredCopingFields.includes(key) ? "8px" : "0",
                    backgroundColor: unansweredCopingFields.includes(key)
                      ? "#d9eaff"
                      : "transparent",
                    borderRadius: unansweredCopingFields.includes(key)
                      ? "8px"
                      : "0",
                  }}
                >
                  <label
                    htmlFor={key}
                    style={{
                      flex: 1,
                      marginRight: 16,
                      fontWeight: "normal",
                      color: unansweredCopingFields.includes(key)
                        ? "#cc0000"
                        : "#333",
                    }}
                  >
                    {label}
                  </label>
                  <select
                    id={key}
                    value={formData[key] || ""}
                    onChange={(e) => handleCopingChange(key, e.target.value)}
                    style={{
                      ...selectStyle,
                      borderColor: unansweredCopingFields.includes(key)
                        ? "#cc0000"
                        : "#ccc",
                      borderWidth: unansweredCopingFields.includes(key)
                        ? "3px"
                        : "2px",
                    }}
                  >
                    <option value="">Select</option>
                    {frequencyOptions.map((opt) => (
                      <option key={opt} value={opt}>
                        {opt}
                      </option>
                    ))}
                  </select>
                </div>
              ))}
              <hr style={{ border: "1px solid #ccc", margin: "24px 0" }} />
              <div className="coping-buttons" style={{ marginTop: 32 }}>
                <button
                  onClick={() => setStep("trauma")}
                  style={{
                    marginTop: 16,
                    width: "100%",
                    backgroundColor: "#fff",
                    color: "#333333",
                    fontWeight: "700",
                    fontSize: 16,
                    borderRadius: 8,
                    padding: "12px 0",
                    border: "none",
                    cursor: "pointer",
                    userSelect: "none",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor = "#e6f0ff")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor = "#fff")
                  }
                >
                  Back
                </button>

                <button
                  onClick={handleCopingSubmit}
                  disabled={isSubmitting}
                  style={{
                    marginTop: 16,
                    width: "100%",
                    backgroundColor: "#0067B3",
                    color: "white",
                    fontWeight: "700",
                    fontSize: 16,
                    borderRadius: 8,
                    padding: "12px 0",
                    border: "none",
                    cursor: "pointer",
                    userSelect: "none",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                  }}
                >
                  {isSubmitting ? "Submitting..." : "Next (Mental Health)"}
                </button>
              </div>
              {copingWarning && (
                <div
                  style={{
                    color: "#cc0000",
                    backgroundColor: "#ffeeee",
                    padding: "10px",
                    borderRadius: "8px",
                    marginBottom: "16px",
                    width: "100%",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  Please answer all coping mechanism questions before
                  continuing.
                </div>
              )}
            </div>
          )}

          {step === "mental" && (
            <div
              className="mental-box"
              style={{
                padding: 24,
                borderRadius: 16,

                userSelect: "none",
              }}
            >
              <h1 style={{ marginBottom: 16, color: "#333" }}>Mental Health</h1>
              <hr style={{ border: "2px solid #ccc", margin: "34px 0" }} />
              <h3 style={{ marginBottom: 16, color: "#0067B3" }}>
                Do you have any mental health diagnoses? Select all that apply:
              </h3>
              {mentalHealthoptions.map(({ key, label }) => (
                <button
                  key={key}
                  type="button"
                  className={`trauma-toggle ${formData[key] ? "selected" : ""}`}
                  onClick={() => toggleBoolean(key)}
                  style={{
                    ...buttonBaseStyle,
                    ...(formData[key] ? selectedButtonStyle : {}),
                    textAlign: "center",
                    display: "block",
                  }}
                >
                  {label}
                </button>
              ))}
              <h3 style={{ marginTop: 24, marginBottom: 12, color: "#0067B3" }}>
                Within the last four weeks, how often did you experience:
              </h3>
              {mentalHealth.map(({ key, label }) => (
                <div
                  key={key}
                  className="coping-collumn"
                  style={{
                    marginBottom: 16,
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column", // <-- vertical layout
                    padding: unansweredMentalFields.includes(key) ? "8px" : "0",
                    backgroundColor: unansweredMentalFields.includes(key)
                      ? "#d9eaff"
                      : "transparent",
                    borderRadius: unansweredMentalFields.includes(key)
                      ? "8px"
                      : "0",
                  }}
                >
                  <label
                    htmlFor={key}
                    style={{
                      flex: 1,
                      marginRight: 16,
                      fontWeight: "normal",
                      color: unansweredMentalFields.includes(key)
                        ? "#cc0000"
                        : "#333",
                    }}
                  >
                    {label}
                  </label>
                  <select
                    id={key}
                    value={formData[key] || ""}
                    onChange={(e) => handleCopingChange(key, e.target.value)}
                    style={{
                      ...selectStyle,
                      borderColor: unansweredMentalFields.includes(key)
                        ? "#cc0000"
                        : "#ccc",
                      borderWidth: unansweredMentalFields.includes(key)
                        ? "3px"
                        : "2px",
                    }}
                  >
                    <option value="">Select</option>
                    {frequencyOptions.map((opt) => (
                      <option key={opt} value={opt}>
                        {opt}
                      </option>
                    ))}
                  </select>
                </div>
              ))}
              <hr style={{ border: "1px solid #ccc", margin: "24px 0" }} />
              <button
                onClick={() => setStep("coping")}
                style={{
                  marginTop: 16,
                  width: "100%",
                  backgroundColor: "#fff",
                  color: "#333333",
                  fontWeight: "700",
                  fontSize: 16,
                  borderRadius: 8,
                  padding: "12px 0",
                  border: "none",
                  cursor: "pointer",
                  userSelect: "none",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = "#e6f0ff")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = "#fff")
                }
              >
                Back
              </button>

              <button
                onClick={handleMentalSubmit}
                disabled={isSubmitting}
                style={{
                  marginTop: 16,
                  width: "100%",
                  backgroundColor: "#0067B3",
                  color: "white",
                  fontWeight: "700",
                  fontSize: 16,
                  borderRadius: 8,
                  padding: "12px 0",
                  border: "none",
                  cursor: "pointer",
                  userSelect: "none",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                }}
              >
                {isSubmitting ? "Submitting..." : "Next (Physical Health)"}
              </button>
              {mentalWarning && (
                <div
                  style={{
                    marginTop: 12,
                    color: "red",
                    textAlign: "center",
                    fontWeight: "500",
                  }}
                >
                  {mentalWarning}
                </div>
              )}
            </div>
          )}
          {step === "physical" && (
            <div
              className="physical-box"
              style={{
                padding: 24,
                borderRadius: 16,

                userSelect: "none",
              }}
            >
              <h1 style={{ marginBottom: 16, color: "#333" }}>
                Physical Health
              </h1>
              <hr style={{ border: "2px solid #ccc", margin: "34px 0" }} />
              <h3 style={{ marginBottom: 16, color: "#0067B3" }}>
                Do you have any physical health diagnoses? Select all that
                apply:
              </h3>
              {physicalHealthOptions.map(({ key, label }) => (
                <button
                  key={key}
                  type="button"
                  className={`trauma-toggle ${formData[key] ? "selected" : ""}`}
                  onClick={() => toggleBoolean(key)}
                  style={{
                    ...buttonBaseStyle,
                    ...(formData[key] ? selectedButtonStyle : {}),
                    textAlign: "center",
                    display: "block",
                  }}
                >
                  {label}
                </button>
              ))}
              <h3 style={{ marginTop: 24, marginBottom: 12, color: "#0067B3" }}>
                Within the last four weeks, how often did you consume at least
                one serving of:
              </h3>
              {physicalHealth.slice(0, 8).map(({ key, label }) => (
                <div
                  key={key}
                  className="coping-collumn"
                  style={{
                    marginBottom: 16,
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column", // <-- vertical layout
                    padding: unansweredPhysicalFields.includes(key)
                      ? "8px"
                      : "0",
                    backgroundColor: unansweredPhysicalFields.includes(key)
                      ? "#d9eaff"
                      : "transparent",
                    borderRadius: unansweredPhysicalFields.includes(key)
                      ? "8px"
                      : "0",
                  }}
                >
                  <label
                    htmlFor={key}
                    style={{
                      flex: 1,
                      marginRight: 16,
                      fontWeight: "normal",
                      color: unansweredPhysicalFields.includes(key)
                        ? "#cc0000"
                        : "#333",
                    }}
                  >
                    {label}
                  </label>
                  <select
                    id={key}
                    value={formData[key] || ""}
                    onChange={(e) => handleCopingChange(key, e.target.value)}
                    style={{
                      ...selectStyle,
                      borderColor: unansweredPhysicalFields.includes(key)
                        ? "#cc0000"
                        : "#ccc",
                      borderWidth: unansweredPhysicalFields.includes(key)
                        ? "3px"
                        : "2px",
                    }}
                  >
                    <option value="">Select</option>
                    {frequencyOptions.map((opt) => (
                      <option key={opt} value={opt}>
                        {opt}
                      </option>
                    ))}
                  </select>
                </div>
              ))}
              <h3 style={{ marginTop: 24, marginBottom: 12, color: "#0067B3" }}>
                Within the last four weeks, how often were you:
              </h3>
              {physicalHealth.slice(-1).map(({ key, label }) => (
                <div
                  key={key}
                  className="coping-collumn"
                  style={{
                    marginBottom: 16,
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column", // <-- vertical layout
                    padding: unansweredPhysicalFields.includes(key)
                      ? "8px"
                      : "0",
                    backgroundColor: unansweredPhysicalFields.includes(key)
                      ? "#d9eaff"
                      : "transparent",
                    borderRadius: unansweredPhysicalFields.includes(key)
                      ? "8px"
                      : "0",
                  }}
                >
                  <label
                    htmlFor={key}
                    style={{
                      flex: 1,
                      marginRight: 16,
                      fontWeight: "normal",
                      color: unansweredPhysicalFields.includes(key)
                        ? "#cc0000"
                        : "#333",
                    }}
                  >
                    {label}
                  </label>
                  <select
                    id={key}
                    value={formData[key] || ""}
                    onChange={(e) => handleCopingChange(key, e.target.value)}
                    style={{
                      ...selectStyle,
                      borderColor: unansweredPhysicalFields.includes(key)
                        ? "#cc0000"
                        : "#ccc",
                      borderWidth: unansweredPhysicalFields.includes(key)
                        ? "3px"
                        : "2px",
                    }}
                  >
                    <option value="">Select</option>
                    {frequencyOptions.map((opt) => (
                      <option key={opt} value={opt}>
                        {opt}
                      </option>
                    ))}
                  </select>
                </div>
              ))}
              <hr style={{ border: "1px solid #ccc", margin: "24px 0" }} />
              <div style={{ display: "grid", rowGap: 16 }}>
                <button
                  onClick={() => setStep("mental")}
                  style={{
                    margin: 0,
                    width: "100%",
                    backgroundColor: "#fff",
                    color: "#333333",
                    fontWeight: "700",
                    fontSize: 16,
                    borderRadius: 8,
                    padding: "12px 0",
                    border: "none",
                    cursor: "pointer",
                    userSelect: "none",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor = "#e6f0ff")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor = "#fff")
                  }
                >
                  Back
                </button>

                <button
                  onClick={handlePhysicalSubmit}
                  disabled={isSubmitting}
                  style={{
                    margin: 0,
                    width: "100%",
                    backgroundColor: "#0067B3",
                    color: "white",
                    fontWeight: "700",
                    fontSize: 16,
                    borderRadius: 8,
                    padding: "12px 0",
                    border: "none",
                    cursor: "pointer",
                    userSelect: "none",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                  }}
                >
                  {isSubmitting ? "Submitting..." : "Next (Spiritual Health)"}
                </button>

                <button
                  onClick={() => {
                    // Skip spiritual health and go to social
                    // Clear any spiritual health data that might exist
                    const clearedData = { ...formData };
                    spiritualHealthOptions.forEach(({ key }) => {
                      delete clearedData[key];
                    });
                    setFormData(clearedData);
                    setStep("social");
                  }}
                  style={{
                    margin: 0,
                    width: "100%",
                    backgroundColor: "#8C1456",
                    color: "#fff",
                    fontWeight: "700",
                    fontSize: 16,
                    borderRadius: 8,
                    padding: "12px 0",
                    border: "none",
                    cursor: "pointer",
                    userSelect: "none",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor = "#6B0E40")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor = "#8C1456")
                  }
                >
                  Skip Spiritual Health
                </button>
              </div>
              {physicalWarning && (
                <div
                  style={{
                    marginTop: 12,
                    color: "red",
                    textAlign: "center",
                    fontWeight: "500",
                  }}
                >
                  {physicalWarning}
                </div>
              )}
            </div>
          )}

          {step === "spiritual" && (
            <div
              className="spiritual-box"
              style={{
                padding: 24,
                borderRadius: 16,

                userSelect: "none",
              }}
            >
              <h1 style={{ marginBottom: 16, color: "#333" }}>
                Spiritual Health
              </h1>
              <hr style={{ border: "2px solid #ccc", margin: "34px 0" }} />
              <h3 style={{ marginTop: 24, marginBottom: 12, color: "#0067B3" }}>
                How much do you agree with the following statements?
              </h3>
              {spiritualHealthOptions.slice(0, 2).map(({ key, label }) => (
                <div
                  key={key}
                  className="coping-collumn"
                  style={{
                    marginBottom: 16,
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    padding: unansweredSpiritualFields.includes(key)
                      ? "8px"
                      : "0",
                    backgroundColor: unansweredSpiritualFields.includes(key)
                      ? "#d9eaff"
                      : "transparent",
                    borderRadius: unansweredSpiritualFields.includes(key)
                      ? "8px"
                      : "0",
                  }}
                >
                  <label
                    htmlFor={key}
                    style={{
                      flex: 1,
                      marginRight: 16,
                      fontWeight: "normal",
                      color: unansweredSpiritualFields.includes(key)
                        ? "#cc0000"
                        : "#333",
                    }}
                  >
                    {label}
                  </label>
                  <select
                    id={key}
                    value={formData[key] || ""}
                    onChange={(e) => handleCopingChange(key, e.target.value)}
                    style={{
                      ...selectStyle,
                      borderColor: unansweredSpiritualFields.includes(key)
                        ? "#cc0000"
                        : "#ccc",
                      borderWidth: unansweredSpiritualFields.includes(key)
                        ? "3px"
                        : "2px",
                    }}
                  >
                    <option value="">Select</option>
                    {frequencyOptions2.map((opt) => (
                      <option key={opt} value={opt}>
                        {opt}
                      </option>
                    ))}
                  </select>
                </div>
              ))}
              <h3 style={{ marginTop: 24, marginBottom: 12, color: "#0067B3" }}>
                Within the last four weeks, how often did you:
              </h3>
              {spiritualHealthOptions.slice(2).map(({ key, label }) => (
                <div
                  key={key}
                  className="coping-collumn"
                  style={{
                    marginBottom: 16,
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    padding: unansweredSpiritualFields.includes(key)
                      ? "8px"
                      : "0",
                    backgroundColor: unansweredSpiritualFields.includes(key)
                      ? "#d9eaff"
                      : "transparent",
                    borderRadius: unansweredSpiritualFields.includes(key)
                      ? "8px"
                      : "0",
                  }}
                >
                  <label
                    htmlFor={key}
                    style={{
                      flex: 1,
                      marginRight: 16,
                      fontWeight: "normal",
                      color: unansweredSpiritualFields.includes(key)
                        ? "#cc0000"
                        : "#333",
                    }}
                  >
                    {label}
                  </label>
                  <select
                    id={key}
                    value={formData[key] || ""}
                    onChange={(e) => handleCopingChange(key, e.target.value)}
                    style={{
                      ...selectStyle,
                      borderColor: unansweredSpiritualFields.includes(key)
                        ? "#cc0000"
                        : "#ccc",
                      borderWidth: unansweredSpiritualFields.includes(key)
                        ? "3px"
                        : "2px",
                    }}
                  >
                    <option value="">Select</option>
                    {frequencyOptions.map((opt) => (
                      <option key={opt} value={opt}>
                        {opt}
                      </option>
                    ))}
                  </select>
                </div>
              ))}
              <hr style={{ border: "1px solid #ccc", margin: "24px 0" }} />
              <div className="coping-buttons" style={{ marginTop: 32 }}>
                <button
                  onClick={() => {
                    // Clear all spiritual health answers when going back
                    const clearedData = { ...formData };
                    spiritualHealthOptions.forEach(({ key }) => {
                      delete clearedData[key];
                    });
                    setFormData(clearedData);
                    setStep("physical");
                  }}
                  style={{
                    marginTop: 16,
                    width: "100%",
                    backgroundColor: "#fff",
                    color: "#333333",
                    fontWeight: "700",
                    fontSize: 16,
                    borderRadius: 8,
                    padding: "12px 0",
                    border: "none",
                    cursor: "pointer",
                    userSelect: "none",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor = "#e6f0ff")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor = "#fff")
                  }
                >
                  Back
                </button>

                <button
                  onClick={handleSpiritualSubmit}
                  disabled={isSubmitting}
                  style={{
                    marginTop: 16,
                    width: "100%",
                    backgroundColor: "#0067B3",
                    color: "white",
                    fontWeight: "700",
                    fontSize: 16,
                    borderRadius: 8,
                    padding: "12px 0",
                    border: "none",
                    cursor: "pointer",
                    userSelect: "none",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                  }}
                >
                  {isSubmitting ? "Submitting..." : "Next (Social Health)"}
                </button>
                {spiritualWarning && (
                  <div
                    style={{
                      marginTop: 12,
                      color: "red",
                      textAlign: "center",
                      fontWeight: "500",
                    }}
                  >
                    {spiritualWarning}
                  </div>
                )}
              </div>
            </div>
          )}

          {step === "social" && (
            <div
              className="spiritual-box"
              style={{
                padding: 24,
                borderRadius: 16,

                userSelect: "none",
              }}
            >
              <h1 style={{ marginBottom: 16, color: "#333" }}>Social Health</h1>
              <hr style={{ border: "2px solid #ccc", margin: "34px 0" }} />
              <h3 style={{ marginTop: 24, marginBottom: 12, color: "#0067B3" }}>
                Within the last four weeks, how often did you experience the
                following:
              </h3>
              {socialhealth.map(({ key, label }) => (
                <div
                  key={key}
                  className="coping-collumn"
                  style={{
                    marginBottom: 16,
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column", // <-- vertical layout
                    padding: unansweredSocialFields.includes(key) ? "8px" : "0",
                    backgroundColor: unansweredSocialFields.includes(key)
                      ? "#d9eaff"
                      : "transparent",
                    borderRadius: unansweredSocialFields.includes(key)
                      ? "8px"
                      : "0",
                  }}
                >
                  <label
                    htmlFor={key}
                    style={{
                      flex: 1,
                      marginRight: 16,
                      fontWeight: "normal",
                      color: unansweredSocialFields.includes(key)
                        ? "#cc0000"
                        : "#333",
                    }}
                  >
                    {label}
                  </label>
                  <select
                    id={key}
                    value={formData[key] || ""}
                    onChange={(e) => handleCopingChange(key, e.target.value)}
                    style={{
                      ...selectStyle,
                      borderColor: unansweredSocialFields.includes(key)
                        ? "#cc0000"
                        : "#ccc",
                      borderWidth: unansweredSocialFields.includes(key)
                        ? "3px"
                        : "2px",
                    }}
                  >
                    <option value="">Select</option>
                    {frequencyOptions.map((opt) => (
                      <option key={opt} value={opt}>
                        {opt}
                      </option>
                    ))}
                  </select>
                </div>
              ))}

              <hr style={{ border: "1px solid #ccc", margin: "24px 0" }} />
              <div className="coping-buttons" style={{ marginTop: 32 }}>
                <button
                  onClick={() => setStep("spiritual")}
                  style={{
                    marginTop: 16,
                    width: "100%",
                    backgroundColor: "#fff",
                    color: "#333333",
                    fontWeight: "700",
                    fontSize: 16,
                    borderRadius: 8,
                    padding: "12px 0",
                    border: "none",
                    cursor: "pointer",
                    userSelect: "none",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor = "#e6f0ff")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor = "#fff")
                  }
                >
                  Back
                </button>

                <button
                  onClick={handleSocialSubmit}
                  disabled={isSubmitting}
                  style={{
                    marginTop: 16,
                    width: "100%",
                    backgroundColor: "#0067B3",
                    color: "white",
                    fontWeight: "700",
                    fontSize: 16,
                    borderRadius: 8,
                    padding: "12px 0",
                    border: "none",
                    cursor: "pointer",
                    userSelect: "none",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                  }}
                >
                  {isSubmitting
                    ? "Submitting..."
                    : "Next (Social Determinants of Health)"}
                </button>
                {socialWarning && (
                  <div
                    style={{
                      marginTop: 12,
                      color: "red",
                      textAlign: "center",
                      fontWeight: "500",
                    }}
                  >
                    {socialWarning}
                  </div>
                )}
              </div>
            </div>
          )}

          {step === "SDOH" && (
            <div
              className="SDOH-box"
              style={{
                padding: 24,
                borderRadius: 16,
                userSelect: "none",
              }}
            >
              <h1 style={{ marginBottom: 16, color: "#333" }}>Demographics</h1>
              <hr style={{ border: "2px solid #ccc", margin: "34px 0" }} />

              {/* Age Range */}
              <h3 style={{ marginBottom: 12, color: "#0067B3" }}>Age Range</h3>
              <select
                name="ageRange"
                value={formData.SDoHAgeRange || ""}
                onChange={(e) =>
                  handleCopingChange("SDoHAgeRange", e.target.value)
                }
                style={selectStyle}
              >
                <option value="">Select Age Range</option>
                {[
                  "9-12",
                  "13-16",
                  "17-19",
                  "20-29",
                  "30-39",
                  "40-49",
                  "50-59",
                  "60-69",
                  "70-79",
                  "80-89",
                  "90-99",
                  "100+",
                ].map((range) => (
                  <option key={range} value={range}>
                    {range}
                  </option>
                ))}
              </select>

              {/* I Identify As */}
              <h3 style={{ marginTop: 24, marginBottom: 12, color: "#0067B3" }}>
                I Identify As
              </h3>
              <select
                name="identify"
                value={
                  IdentifyAsOptions.includes(formData.SDoHRace)
                    ? formData.SDoHRace
                    : formData.SDoHRace
                      ? "Other"
                      : ""
                }
                onChange={(e) => {
                  const selected = e.target.value;
                  handleCopingChange("SDoHRace", selected);
                }}
                style={selectStyle}
              >
                <option value="">Select Race</option>
                {IdentifyAsOptions.slice(0, -2).map((eth) => (
                  <option key={eth} value={eth}>
                    {eth}
                  </option>
                ))}
              </select>

              {formData.SDoHRace &&
                (formData.SDoHRace === "Other" ||
                  (!IdentifyAsOptions.includes(formData.SDoHRace) &&
                    formData.SDoHRace !== "No Answer")) && (
                  <input
                    type="text"
                    placeholder="Please specify"
                    value={
                      formData.SDoHRace === "Other"
                        ? ""
                        : formData.SDoHRace || ""
                    }
                    onChange={(e) =>
                      handleCopingChange("SDoHRace", e.target.value)
                    }
                    style={{ ...selectStyle, marginTop: 8 }}
                  />
                )}

              {/* Primary Nationality/Geographic Region */}
              <h3 style={{ marginTop: 24, marginBottom: 12, color: "#0067B3" }}>
                What is your primary nationality/geographic region?
              </h3>
              <select
                name="nationality"
                value={
                  NationalityOptions.includes(formData.SDoHGeographicRegion)
                    ? formData.SDoHGeographicRegion
                    : formData.SDoHGeographicRegion
                      ? "Other"
                      : ""
                }
                onChange={(e) => {
                  const selected = e.target.value;
                  handleCopingChange("SDoHGeographicRegion", selected);
                }}
                style={selectStyle}
              >
                <option value="">Select Nationality</option>
                {NationalityOptions.slice(0, -2).map((eth) => (
                  <option key={eth} value={eth}>
                    {eth}
                  </option>
                ))}
              </select>

              {formData.SDoHGeographicRegion &&
                (formData.SDoHGeographicRegion === "Other" ||
                  (!NationalityOptions.includes(
                    formData.SDoHGeographicRegion,
                  ) &&
                    formData.SDoHGeographicRegion !== "No Answer")) && (
                  <input
                    type="text"
                    placeholder="Please specify"
                    value={
                      formData.SDoHGeographicRegion === "Other"
                        ? ""
                        : formData.SDoHGeographicRegion || ""
                    }
                    onChange={(e) =>
                      handleCopingChange("SDoHGeographicRegion", e.target.value)
                    }
                    style={{ ...selectStyle, marginTop: 8 }}
                  />
                )}

              {/* Primary Ethnicity */}
              <h3 style={{ marginTop: 24, marginBottom: 12, color: "#0067B3" }}>
                What is your primary ethnicity?
              </h3>
              <select
                name="ethnicity"
                value={
                  ethnicityOptions.includes(formData.SDoHEthnicity)
                    ? formData.SDoHEthnicity
                    : formData.SDoHEthnicity
                      ? "Other"
                      : ""
                }
                onChange={(e) => {
                  const selected = e.target.value;
                  handleCopingChange("SDoHEthnicity", selected);
                }}
                style={selectStyle}
              >
                <option value="">Select Ethnicity</option>
                {ethnicityOptions.slice(0, -2).map((eth) => (
                  <option key={eth} value={eth}>
                    {eth}
                  </option>
                ))}
              </select>

              {formData.SDoHEthnicity &&
                (formData.SDoHEthnicity === "Other" ||
                  (!ethnicityOptions.includes(formData.SDoHEthnicity) &&
                    formData.SDoHEthnicity !== "No Answer")) && (
                  <input
                    type="text"
                    placeholder="Please specify"
                    value={
                      formData.SDoHEthnicity === "Other"
                        ? ""
                        : formData.SDoHEthnicity || ""
                    }
                    onChange={(e) =>
                      handleCopingChange("SDoHEthnicity", e.target.value)
                    }
                    style={{ ...selectStyle, marginTop: 8 }}
                  />
                )}

              {/* State */}
              <h3 style={{ marginTop: 24, marginBottom: 12, color: "#0067B3" }}>
                State
              </h3>
              <select
                name="state"
                value={formData.SDoHState || ""}
                onChange={(e) =>
                  handleCopingChange("SDoHState", e.target.value)
                }
                style={selectStyle}
              >
                <option value="">Select State</option>
                {[
                  "Alabama",
                  "Alaska",
                  "Arizona",
                  "Arkansas",
                  "California",
                  "Colorado",
                  "Connecticut",
                  "Delaware",
                  "Florida",
                  "Georgia",
                  "Hawaii",
                  "Idaho",
                  "Illinois",
                  "Indiana",
                  "Iowa",
                  "Kansas",
                  "Kentucky",
                  "Louisiana",
                  "Maine",
                  "Maryland",
                  "Massachusetts",
                  "Michigan",
                  "Minnesota",
                  "Mississippi",
                  "Missouri",
                  "Montana",
                  "Nebraska",
                  "Nevada",
                  "New Hampshire",
                  "New Jersey",
                  "New Mexico",
                  "New York",
                  "North Carolina",
                  "North Dakota",
                  "Ohio",
                  "Oklahoma",
                  "Oregon",
                  "Pennsylvania",
                  "Rhode Island",
                  "South Carolina",
                  "South Dakota",
                  "Tennessee",
                  "Texas",
                  "Utah",
                  "Vermont",
                  "Virginia",
                  "Washington",
                  "West Virginia",
                  "Wisconsin",
                  "Wyoming",
                ].map((state) => (
                  <option key={state} value={state}>
                    {state}
                  </option>
                ))}
              </select>

              {/* Zip Code */}
              <h3 style={{ marginTop: 24, marginBottom: 12, color: "#0067B3" }}>
                Zip Code
              </h3>
              <input
                type="text"
                name="zipCode"
                placeholder="Enter Zip Code"
                value={formData.SDoHZipCode || ""}
                onChange={(e) =>
                  handleCopingChange("SDoHZipCode", e.target.value)
                }
                style={selectStyle}
              />

              {/* Current Marital Status */}
              <h3 style={{ marginTop: 24, marginBottom: 12, color: "#0067B3" }}>
                Current Marital Status
              </h3>
              <select
                name="maritalStatus"
                value={formData.SDoHMaritalStatus || ""}
                onChange={(e) =>
                  handleCopingChange("SDoHMaritalStatus", e.target.value)
                }
                style={selectStyle}
              >
                <option value="">Select Marital Status</option>
                {["Single", "Married", "Divorced", "Widowed"].map((status) => (
                  <option key={status} value={status}>
                    {status}
                  </option>
                ))}
              </select>

              {/* Military Status */}
              <h3 style={{ marginTop: 24, marginBottom: 12, color: "#0067B3" }}>
                Military Status
              </h3>
              <select
                name="militaryStatus"
                value={formData.SDoHMilitaryStatus || ""}
                onChange={(e) =>
                  handleCopingChange("SDoHMilitaryStatus", e.target.value)
                }
                style={selectStyle}
              >
                <option value="">Select Military Status</option>
                {["Active", "Discharged", "Veteran", "Not Applicable"].map(
                  (status) => (
                    <option key={status} value={status}>
                      {status}
                    </option>
                  ),
                )}
              </select>

              {/* Gender Identity */}
              <h3 style={{ marginTop: 24, marginBottom: 12, color: "#0067B3" }}>
                I Identify As
              </h3>
              <select
                name="gender"
                value={
                  GenderIdentityOptions.includes(formData.SDoHGender)
                    ? formData.SDoHGender
                    : formData.SDoHGender
                      ? "Other"
                      : ""
                }
                onChange={(e) => {
                  const selected = e.target.value;
                  handleCopingChange("SDoHGender", selected);
                }}
                style={selectStyle}
              >
                <option value="">Select Gender</option>
                {GenderIdentityOptions.slice(0, -2).map((eth) => (
                  <option key={eth} value={eth}>
                    {eth}
                  </option>
                ))}
              </select>

              {formData.SDoHGender &&
                (formData.SDoHGender === "Other" ||
                  (!GenderIdentityOptions.includes(formData.SDoHGender) &&
                    formData.SDoHGender !== "No Answer")) && (
                  <input
                    type="text"
                    placeholder="Please specify"
                    value={
                      formData.SDoHGender === "Other"
                        ? ""
                        : formData.SDoHGender || ""
                    }
                    onChange={(e) =>
                      handleCopingChange("SDoHGender", e.target.value)
                    }
                    style={{ ...selectStyle, marginTop: 8 }}
                  />
                )}

              {/* Education */}
              <h3 style={{ marginTop: 24, marginBottom: 12, color: "#0067B3" }}>
                Education
              </h3>
              <select
                name="education"
                value={formData.SDoHEducation || ""}
                onChange={(e) =>
                  handleCopingChange("SDoHEducation", e.target.value)
                }
                style={selectStyle}
              >
                <option value="">Select Highest Education</option>
                {[
                  "No Diploma",
                  "HS Diploma",
                  "Vocational",
                  "Bachelors",
                  "Masters",
                  "Doctorate",
                ].map((edu) => (
                  <option key={edu} value={edu}>
                    {edu}
                  </option>
                ))}
              </select>

              {/* Job Status */}
              <h3 style={{ marginTop: 24, marginBottom: 12, color: "#0067B3" }}>
                Job Status
              </h3>
              <select
                name="jobStatus"
                value={formData.SDoHJobStatus || ""}
                onChange={(e) =>
                  handleCopingChange("SDoHJobStatus", e.target.value)
                }
                style={selectStyle}
              >
                <option value="">Select Job Status</option>
                {["Employed", "Unemployed", "Self Employed"].map((job) => (
                  <option key={job} value={job}>
                    {job}
                  </option>
                ))}
              </select>

              {/* Income */}
              <h3 style={{ marginTop: 24, marginBottom: 12, color: "#0067B3" }}>
                Income
              </h3>
              <select
                name="income"
                value={formData.SDoHIncome || ""}
                onChange={(e) =>
                  handleCopingChange("SDoHIncome", e.target.value)
                }
                style={selectStyle}
              >
                <option value="">Select Income Range</option>
                {[
                  "$0-$20K",
                  "$21K-$40K",
                  "$41K-$70K",
                  "$71K-100K",
                  "$101K-500K",
                  "$501K +",
                ].map((income) => (
                  <option key={income} value={income}>
                    {income}
                  </option>
                ))}
              </select>

              {/* Housing Status */}
              <h3 style={{ marginTop: 24, marginBottom: 12, color: "#0067B3" }}>
                Housing Status
              </h3>
              <select
                name="housing"
                value={
                  HousingOptions.includes(formData.SDoHHousingStatus)
                    ? formData.SDoHHousingStatus
                    : formData.SDoHHousingStatus
                      ? "Other"
                      : ""
                }
                onChange={(e) => {
                  const selected = e.target.value;
                  handleCopingChange("SDoHHousingStatus", selected);
                }}
                style={selectStyle}
              >
                <option value="">Select Housing Status</option>
                {HousingOptions.slice(0, -2).map((eth) => (
                  <option key={eth} value={eth}>
                    {eth}
                  </option>
                ))}
              </select>

              {formData.SDoHHousingStatus &&
                (formData.SDoHHousingStatus === "Other" ||
                  (!HousingOptions.includes(formData.SDoHHousingStatus) &&
                    formData.SDoHHousingStatus !== "No Answer")) && (
                  <input
                    type="text"
                    placeholder="Please specify"
                    value={
                      formData.SDoHHousingStatus === "Other"
                        ? ""
                        : formData.SDoHHousingStatus || ""
                    }
                    onChange={(e) =>
                      handleCopingChange("SDoHHousingStatus", e.target.value)
                    }
                    style={{ ...selectStyle, marginTop: 8 }}
                  />
                )}

              {/* Type of home grew up in */}
              <h3 style={{ marginTop: 24, marginBottom: 12, color: "#0067B3" }}>
                What type of home did you grow up in?
              </h3>
              <select
                name="home"
                value={
                  HomeGrewUpOptions.includes(formData.SDoHHomeAsChild)
                    ? formData.SDoHHomeAsChild
                    : formData.SDoHHomeAsChild
                      ? "Other"
                      : ""
                }
                onChange={(e) => {
                  const selected = e.target.value;
                  handleCopingChange("SDoHHomeAsChild", selected);
                }}
                style={selectStyle}
              >
                <option value="">Select Type</option>
                {HomeGrewUpOptions.slice(0, -2).map((eth) => (
                  <option key={eth} value={eth}>
                    {eth}
                  </option>
                ))}
              </select>

              {formData.SDoHHomeAsChild &&
                (formData.SDoHHomeAsChild === "Other" ||
                  (!HomeGrewUpOptions.includes(formData.SDoHHomeAsChild) &&
                    formData.SDoHHomeAsChild !== "No Answer")) && (
                  <input
                    type="text"
                    placeholder="Please specify"
                    value={
                      formData.SDoHHomeAsChild === "Other"
                        ? ""
                        : formData.SDoHHomeAsChild || ""
                    }
                    onChange={(e) =>
                      handleCopingChange("SDoHHomeAsChild", e.target.value)
                    }
                    style={{ ...selectStyle, marginTop: 8 }}
                  />
                )}

              {/* Religion */}
              <h3 style={{ marginTop: 24, marginBottom: 12, color: "#0067B3" }}>
                Which religion provides you with strength and hope?
              </h3>
              <select
                name="religion"
                value={formData.SDoHReligion || ""}
                onChange={(e) =>
                  handleCopingChange("SDoHReligion", e.target.value)
                }
                style={selectStyle}
              >
                <option value="">Select Religion</option>
                {[
                  "Buddhism",
                  "Christianity",
                  "Hinduism",
                  "Islam",
                  "Judaism",
                  "None or N/A",
                ].map((religion) => (
                  <option key={religion} value={religion}>
                    {religion}
                  </option>
                ))}
              </select>
              {formData.religion === "Other" && (
                <input
                  type="text"
                  name="religionOther"
                  placeholder="Please specify"
                  value={formData.religionOther || ""}
                  onChange={handleInputChange}
                  style={{ ...selectStyle, marginTop: 8 }}
                />
              )}

              {/* Denomination dropdown - only show if religion is exactly 'Christianity' */}
              {formData.SDoHReligion === "Christianity" && (
                <>
                  <h3
                    style={{
                      marginTop: 24,
                      marginBottom: 12,
                      color: "#0067B3",
                    }}
                  >
                    Please select your Christian denomination
                  </h3>
                  <select
                    name="denomination"
                    value={
                      DenominationOptions.includes(formData.SDoHDenomination)
                        ? formData.SDoHDenomination
                        : formData.SDoHDenomination
                          ? "Other"
                          : ""
                    }
                    onChange={(e) => {
                      const selected = e.target.value;
                      handleCopingChange("SDoHDenomination", selected);
                    }}
                    style={selectStyle}
                  >
                    <option value="">Select Denomination</option>
                    {DenominationOptions.slice(0, -2).map((eth) => (
                      <option key={eth} value={eth}>
                        {eth}
                      </option>
                    ))}
                  </select>

                  {formData.SDoHDenomination &&
                    (formData.SDoHDenomination === "Other" ||
                      (!DenominationOptions.includes(
                        formData.SDoHDenomination,
                      ) &&
                        formData.SDoHDenomination !== "No Answer")) && (
                      <input
                        type="text"
                        placeholder="Please specify"
                        value={
                          formData.SDoHDenomination === "Other"
                            ? ""
                            : formData.SDoHDenomination || ""
                        }
                        onChange={(e) =>
                          handleCopingChange("SDoHDenomination", e.target.value)
                        }
                        style={{ ...selectStyle, marginTop: 8 }}
                      />
                    )}
                </>
              )}

              <hr style={{ border: "1px solid #ccc", margin: "24px 0" }} />
              {/* Buttons */}
              <div style={{ marginTop: 32 }}>
                <button
                  onClick={() => setStep("social")} // replace previousStep with actual previous step string
                  style={{
                    marginTop: 16,
                    width: "100%",
                    backgroundColor: "#fff",
                    color: "#333333",
                    fontWeight: "700",
                    fontSize: 16,
                    borderRadius: 8,
                    padding: "12px 0",
                    border: "none",
                    cursor: "pointer",
                    userSelect: "none",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor = "#e6f0ff")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor = "#fff")
                  }
                >
                  Back
                </button>

                <button
                  onClick={() => handleSDOHSubmit()}
                  disabled={isSubmitting}
                  style={{
                    marginTop: 16,
                    width: "100%",
                    backgroundColor: "#0067B3",
                    color: "white",
                    fontWeight: "700",
                    fontSize: 16,
                    borderRadius: 8,
                    padding: "12px 0",
                    border: "none",
                    cursor: "pointer",
                    userSelect: "none",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                  }}
                >
                  {isSubmitting ? "Submitting..." : "Submit"}
                </button>
                {sdohWarning && (
                  <div
                    style={{
                      marginTop: 12,
                      color: "red",
                      textAlign: "center",
                      fontWeight: "500",
                    }}
                  >
                    {sdohWarning}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
